//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IArticlesApiService {
    getPagedArticles(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfArticleDto>;
    createArticle(dto: ArticleDto): Observable<ApiResponseOfArticleDto>;
    deleteBulkArticles(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfArticleDto>;
    getArticle(id: number): Observable<ApiResponseOfArticleDto>;
    updateArticle(id: number, dto: ArticleDto): Observable<ApiResponseOfArticleDto>;
    deleteArticle(id: number): Observable<ApiResponseOfArticleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ArticlesApiService implements IArticlesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedArticles(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfArticleDto>;
        }));
    }

    protected processGetPagedArticles(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfArticleDto>(null as any);
    }

    createArticle(dto: ArticleDto): Observable<ApiResponseOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArticleDto>;
        }));
    }

    protected processCreateArticle(response: HttpResponseBase): Observable<ApiResponseOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfArticleDto>(null as any);
    }

    deleteBulkArticles(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfArticleDto>;
        }));
    }

    protected processDeleteBulkArticles(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfArticleDto>(null as any);
    }

    getArticle(id: number): Observable<ApiResponseOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArticleDto>;
        }));
    }

    protected processGetArticle(response: HttpResponseBase): Observable<ApiResponseOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfArticleDto>(null as any);
    }

    updateArticle(id: number, dto: ArticleDto): Observable<ApiResponseOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArticleDto>;
        }));
    }

    protected processUpdateArticle(response: HttpResponseBase): Observable<ApiResponseOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfArticleDto>(null as any);
    }

    deleteArticle(id: number): Observable<ApiResponseOfArticleDto> {
        let url_ = this.baseUrl + "/api/articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfArticleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfArticleDto>;
        }));
    }

    protected processDeleteArticle(response: HttpResponseBase): Observable<ApiResponseOfArticleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfArticleDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfArticleDto>(null as any);
    }
}

export interface IExportsApiService {
    requestBookingRecordsExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString>;
    downloadBookingRecordsExport(token?: string | undefined): Observable<FileResponse>;
    requestCustomerAccountsExport(): Observable<ApiResponseOfString>;
    downloadCustomerAccountsExport(token?: string | undefined): Observable<FileResponse>;
    requestTotalGrossBalanceExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString>;
    downloadTotalGrossBalanceExport(token?: string | undefined): Observable<FileResponse>;
    requestTotalNetBalanceExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString>;
    downloadTotalNetBalanceExport(token?: string | undefined): Observable<FileResponse>;
    requestReceiptListExport(fromDate?: string | undefined, toDate?: string | undefined, receiptType?: ReceiptType | undefined, customerIds?: number[] | undefined, statusIds?: number[] | undefined): Observable<ApiResponseOfString>;
    downloadReceiptListExport(token?: string | undefined): Observable<FileResponse>;
    requestRap(): Observable<ApiResponseOfString>;
    downloadRap(token?: string | undefined): Observable<FileResponse>;
    requestInvoiceRevenue(startDate?: string | undefined, endDate?: string | undefined): Observable<ApiResponseOfString>;
    downloadInvoiceRevenue(token?: string | undefined): Observable<FileResponse>;
    requestAbroadArticlesExport(): Observable<ApiResponseOfString>;
    downloadAbroadArticles(token?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportsApiService implements IExportsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    requestBookingRecordsExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestBookingRecords?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (shouldRelease === null)
            throw new Error("The parameter 'shouldRelease' cannot be null.");
        else if (shouldRelease !== undefined)
            url_ += "shouldRelease=" + encodeURIComponent("" + shouldRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestBookingRecordsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestBookingRecordsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestBookingRecordsExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadBookingRecordsExport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadBookingRecords?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadBookingRecordsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadBookingRecordsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadBookingRecordsExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestCustomerAccountsExport(): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestCustomerAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestCustomerAccountsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestCustomerAccountsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestCustomerAccountsExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadCustomerAccountsExport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadCustomerAccounts?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadCustomerAccountsExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadCustomerAccountsExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadCustomerAccountsExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestTotalGrossBalanceExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestTotalGrossBalance?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (shouldRelease === null)
            throw new Error("The parameter 'shouldRelease' cannot be null.");
        else if (shouldRelease !== undefined)
            url_ += "shouldRelease=" + encodeURIComponent("" + shouldRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestTotalGrossBalanceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTotalGrossBalanceExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestTotalGrossBalanceExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadTotalGrossBalanceExport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadTotalGrossBalance?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTotalGrossBalanceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTotalGrossBalanceExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTotalGrossBalanceExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestTotalNetBalanceExport(startDate?: string | undefined, endDate?: string | undefined, shouldRelease?: boolean | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestTotalNetBalance?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        if (shouldRelease === null)
            throw new Error("The parameter 'shouldRelease' cannot be null.");
        else if (shouldRelease !== undefined)
            url_ += "shouldRelease=" + encodeURIComponent("" + shouldRelease) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestTotalNetBalanceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestTotalNetBalanceExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestTotalNetBalanceExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadTotalNetBalanceExport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadTotalNetBalance?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadTotalNetBalanceExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadTotalNetBalanceExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadTotalNetBalanceExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestReceiptListExport(fromDate?: string | undefined, toDate?: string | undefined, receiptType?: ReceiptType | undefined, customerIds?: number[] | undefined, statusIds?: number[] | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestReceiptList?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (receiptType === null)
            throw new Error("The parameter 'receiptType' cannot be null.");
        else if (receiptType !== undefined)
            url_ += "receiptType=" + encodeURIComponent("" + receiptType) + "&";
        if (customerIds === null)
            throw new Error("The parameter 'customerIds' cannot be null.");
        else if (customerIds !== undefined)
            customerIds && customerIds.forEach(item => { url_ += "customerIds=" + encodeURIComponent("" + item) + "&"; });
        if (statusIds === null)
            throw new Error("The parameter 'statusIds' cannot be null.");
        else if (statusIds !== undefined)
            statusIds && statusIds.forEach(item => { url_ += "statusIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReceiptListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReceiptListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestReceiptListExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadReceiptListExport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadReceiptList?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReceiptListExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReceiptListExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReceiptListExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestRap(): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestRap";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestRap(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadRap(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadRap?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadRap(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestInvoiceRevenue(startDate?: string | undefined, endDate?: string | undefined): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestInvoiceRevenue?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestInvoiceRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestInvoiceRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestInvoiceRevenue(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadInvoiceRevenue(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadInvoiceRevenue?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInvoiceRevenue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInvoiceRevenue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInvoiceRevenue(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    requestAbroadArticlesExport(): Observable<ApiResponseOfString> {
        let url_ = this.baseUrl + "/api/Exports/requestAbroadArticles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestAbroadArticlesExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestAbroadArticlesExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfString>;
        }));
    }

    protected processRequestAbroadArticlesExport(response: HttpResponseBase): Observable<ApiResponseOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfString;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfString>(null as any);
    }

    downloadAbroadArticles(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Exports/downloadAbroadArticles?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAbroadArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAbroadArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAbroadArticles(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IWarehousesApiService {
    getPaged(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfWarehouseDto>;
    createWarehouse(dto: WarehouseDto): Observable<ApiResponseOfWarehouseDto>;
    deleteBulkWarehouses(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfWarehouseDto>;
    getWarehouseById(id: number): Observable<ApiResponseOfWarehouseDto>;
    updateWarehouse(id: number, dto: WarehouseDto): Observable<ApiResponseOfWarehouseDto>;
    deleteWarehouse(id: number): Observable<ApiResponseOfWarehouseDto>;
}

@Injectable({
    providedIn: 'root'
})
export class WarehousesApiService implements IWarehousesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPaged(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfWarehouseDto>;
        }));
    }

    protected processGetPaged(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfWarehouseDto>(null as any);
    }

    createWarehouse(dto: WarehouseDto): Observable<ApiResponseOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfWarehouseDto>;
        }));
    }

    protected processCreateWarehouse(response: HttpResponseBase): Observable<ApiResponseOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfWarehouseDto>(null as any);
    }

    deleteBulkWarehouses(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkWarehouses(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkWarehouses(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfWarehouseDto>;
        }));
    }

    protected processDeleteBulkWarehouses(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfWarehouseDto>(null as any);
    }

    getWarehouseById(id: number): Observable<ApiResponseOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWarehouseById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWarehouseById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfWarehouseDto>;
        }));
    }

    protected processGetWarehouseById(response: HttpResponseBase): Observable<ApiResponseOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfWarehouseDto>(null as any);
    }

    updateWarehouse(id: number, dto: WarehouseDto): Observable<ApiResponseOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfWarehouseDto>;
        }));
    }

    protected processUpdateWarehouse(response: HttpResponseBase): Observable<ApiResponseOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfWarehouseDto>(null as any);
    }

    deleteWarehouse(id: number): Observable<ApiResponseOfWarehouseDto> {
        let url_ = this.baseUrl + "/api/Warehouses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWarehouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWarehouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfWarehouseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfWarehouseDto>;
        }));
    }

    protected processDeleteWarehouse(response: HttpResponseBase): Observable<ApiResponseOfWarehouseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfWarehouseDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfWarehouseDto>(null as any);
    }
}

export interface IVehiclesApiService {
    getPagedVehicles(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfVehicleDto>;
    createVehicle(dto: VehicleDto): Observable<ApiResponseOfVehicleDto>;
    deleteBulkVehicles(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfVehicleDto>;
    getVehicle(id: number): Observable<ApiResponseOfVehicleDto>;
    updateVehicle(id: number, dto: VehicleDto): Observable<ApiResponseOfVehicleDto>;
    deleteVehicle(id: number): Observable<ApiResponseOfVehicleDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VehiclesApiService implements IVehiclesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedVehicles(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfVehicleDto>;
        }));
    }

    protected processGetPagedVehicles(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfVehicleDto>(null as any);
    }

    createVehicle(dto: VehicleDto): Observable<ApiResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleDto>;
        }));
    }

    protected processCreateVehicle(response: HttpResponseBase): Observable<ApiResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleDto>(null as any);
    }

    deleteBulkVehicles(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkVehicles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkVehicles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfVehicleDto>;
        }));
    }

    protected processDeleteBulkVehicles(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfVehicleDto>(null as any);
    }

    getVehicle(id: number): Observable<ApiResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleDto>;
        }));
    }

    protected processGetVehicle(response: HttpResponseBase): Observable<ApiResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleDto>(null as any);
    }

    updateVehicle(id: number, dto: VehicleDto): Observable<ApiResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleDto>;
        }));
    }

    protected processUpdateVehicle(response: HttpResponseBase): Observable<ApiResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleDto>(null as any);
    }

    deleteVehicle(id: number): Observable<ApiResponseOfVehicleDto> {
        let url_ = this.baseUrl + "/api/vehicles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleDto>;
        }));
    }

    protected processDeleteVehicle(response: HttpResponseBase): Observable<ApiResponseOfVehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleDto>(null as any);
    }
}

export interface IVehicleTypesApiService {
    getPagedVehicleTypes(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfVehicleTypeDto>;
    createVehicleType(dto: VehicleTypeDto): Observable<ApiResponseOfVehicleTypeDto>;
    deleteBulkVehicleTypes(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfVehicleTypeDto>;
    getVehicleType(id: number): Observable<ApiResponseOfVehicleTypeDto>;
    updateVehicleType(id: number, dto: VehicleTypeDto): Observable<ApiResponseOfVehicleTypeDto>;
    deleteVehicleType(id: number): Observable<ApiResponseOfVehicleTypeDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VehicleTypesApiService implements IVehicleTypesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedVehicleTypes(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedVehicleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfVehicleTypeDto>;
        }));
    }

    protected processGetPagedVehicleTypes(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfVehicleTypeDto>(null as any);
    }

    createVehicleType(dto: VehicleTypeDto): Observable<ApiResponseOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateVehicleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateVehicleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleTypeDto>;
        }));
    }

    protected processCreateVehicleType(response: HttpResponseBase): Observable<ApiResponseOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleTypeDto>(null as any);
    }

    deleteBulkVehicleTypes(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkVehicleTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkVehicleTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfVehicleTypeDto>;
        }));
    }

    protected processDeleteBulkVehicleTypes(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfVehicleTypeDto>(null as any);
    }

    getVehicleType(id: number): Observable<ApiResponseOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleTypeDto>;
        }));
    }

    protected processGetVehicleType(response: HttpResponseBase): Observable<ApiResponseOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleTypeDto>(null as any);
    }

    updateVehicleType(id: number, dto: VehicleTypeDto): Observable<ApiResponseOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateVehicleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateVehicleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleTypeDto>;
        }));
    }

    protected processUpdateVehicleType(response: HttpResponseBase): Observable<ApiResponseOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleTypeDto>(null as any);
    }

    deleteVehicleType(id: number): Observable<ApiResponseOfVehicleTypeDto> {
        let url_ = this.baseUrl + "/api/vehicles/types/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVehicleType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVehicleType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfVehicleTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfVehicleTypeDto>;
        }));
    }

    protected processDeleteVehicleType(response: HttpResponseBase): Observable<ApiResponseOfVehicleTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfVehicleTypeDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfVehicleTypeDto>(null as any);
    }
}

export interface IGoogleApiKeyApiService {
    loadGoogleApiKey(): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class GoogleApiKeyApiService implements IGoogleApiKeyApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    loadGoogleApiKey(): Observable<string> {
        let url_ = this.baseUrl + "/api/GoogleApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadGoogleApiKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadGoogleApiKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLoadGoogleApiKey(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

export interface IPlateCountStatisticsApiService {
    loadPlateCounts(zipCodeDigitLimit?: number | undefined): Observable<ApiResponseOfListOfPlateCountStatisticDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PlateCountStatisticsApiService implements IPlateCountStatisticsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    loadPlateCounts(zipCodeDigitLimit?: number | undefined): Observable<ApiResponseOfListOfPlateCountStatisticDto> {
        let url_ = this.baseUrl + "/api/PlateCountStatistics?";
        if (zipCodeDigitLimit === null)
            throw new Error("The parameter 'zipCodeDigitLimit' cannot be null.");
        else if (zipCodeDigitLimit !== undefined)
            url_ += "zipCodeDigitLimit=" + encodeURIComponent("" + zipCodeDigitLimit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadPlateCounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadPlateCounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfPlateCountStatisticDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfPlateCountStatisticDto>;
        }));
    }

    protected processLoadPlateCounts(response: HttpResponseBase): Observable<ApiResponseOfListOfPlateCountStatisticDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfPlateCountStatisticDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfPlateCountStatisticDto>(null as any);
    }
}

export interface IApplicationSettingsApiService {
    getApplicationSettings(): Observable<ApiResponseOfApplicationSettingsDto>;
    updateApplicationSettings(dto: ApplicationSettingsDto): Observable<ApiResponseOfApplicationSettingsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationSettingsApiService implements IApplicationSettingsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getApplicationSettings(): Observable<ApiResponseOfApplicationSettingsDto> {
        let url_ = this.baseUrl + "/api/applicationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfApplicationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfApplicationSettingsDto>;
        }));
    }

    protected processGetApplicationSettings(response: HttpResponseBase): Observable<ApiResponseOfApplicationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApplicationSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfApplicationSettingsDto>(null as any);
    }

    updateApplicationSettings(dto: ApplicationSettingsDto): Observable<ApiResponseOfApplicationSettingsDto> {
        let url_ = this.baseUrl + "/api/applicationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfApplicationSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfApplicationSettingsDto>;
        }));
    }

    protected processUpdateApplicationSettings(response: HttpResponseBase): Observable<ApiResponseOfApplicationSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApplicationSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfApplicationSettingsDto>(null as any);
    }
}

export interface IReceiptExportFieldSettingsApiService {
    getAllByType(receiptType?: ReceiptExportType | undefined): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
    updateSettings(receiptType: ReceiptExportType, newSettings: { [key: string]: number; }): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ReceiptExportFieldSettingsApiService implements IReceiptExportFieldSettingsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllByType(receiptType?: ReceiptExportType | undefined): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto> {
        let url_ = this.baseUrl + "/api/applicationSettings/receiptExportFields?";
        if (receiptType === null)
            throw new Error("The parameter 'receiptType' cannot be null.");
        else if (receiptType !== undefined)
            url_ += "receiptType=" + encodeURIComponent("" + receiptType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
        }));
    }

    protected processGetAllByType(response: HttpResponseBase): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfReceiptExportFieldSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfReceiptExportFieldSettingsDto>(null as any);
    }

    updateSettings(receiptType: ReceiptExportType, newSettings: { [key: string]: number; }): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto> {
        let url_ = this.baseUrl + "/api/applicationSettings/receiptExportFields/{receiptType}";
        if (receiptType === undefined || receiptType === null)
            throw new Error("The parameter 'receiptType' must be defined.");
        url_ = url_.replace("{receiptType}", encodeURIComponent("" + receiptType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newSettings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto>;
        }));
    }

    protected processUpdateSettings(response: HttpResponseBase): Observable<ApiResponseOfListOfReceiptExportFieldSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfReceiptExportFieldSettingsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfReceiptExportFieldSettingsDto>(null as any);
    }
}

export interface IOrderKindsApiService {
    getTransferKinds(orderId: number): Observable<ApiResponseOfListOfString>;
    getKinds(): Observable<ApiResponseOfListOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderKindsApiService implements IOrderKindsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getTransferKinds(orderId: number): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/orders/kinds/transfer/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetTransferKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }

    getKinds(): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/orders/kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }
}

export interface IOrdersApiService {
    getTransferData(orderId: number): Observable<ApiResponseOfTransferOrderDto>;
    requestReportDownload(orderId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOrderDto>;
    getReceipt(receiptId: number): Observable<ApiResponseOfOrderDto>;
    updateReceipt(receiptId: number, dto: OrderVersionDto): Observable<ApiResponseOfOrderVersionDto>;
    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfOrderPositionDto>;
    updateStatus(updateDto: ReceiptStatusUpdateDtoOfOrderDtoAndOrderStatusDto): Observable<ApiResponseOfListOfOrderVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OrdersApiService implements IOrdersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getTransferData(orderId: number): Observable<ApiResponseOfTransferOrderDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/transfer/data";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfTransferOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfTransferOrderDto>;
        }));
    }

    protected processGetTransferData(response: HttpResponseBase): Observable<ApiResponseOfTransferOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfTransferOrderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTransferOrderDto>(null as any);
    }

    requestReportDownload(orderId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/downloadReport?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (documentMode === null)
            throw new Error("The parameter 'documentMode' cannot be null.");
        else if (documentMode !== undefined)
            url_ += "documentMode=" + encodeURIComponent("" + documentMode) + "&";
        if (attachAgb === null)
            throw new Error("The parameter 'attachAgb' cannot be null.");
        else if (attachAgb !== undefined)
            url_ += "attachAgb=" + encodeURIComponent("" + attachAgb) + "&";
        if (attachImportantNotes === null)
            throw new Error("The parameter 'attachImportantNotes' cannot be null.");
        else if (attachImportantNotes !== undefined)
            url_ += "attachImportantNotes=" + encodeURIComponent("" + attachImportantNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/orders/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOrderDto> {
        let url_ = this.baseUrl + "/api/orders?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfOrderDto>;
        }));
    }

    protected processGetPagedReceipts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfOrderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfOrderDto>(null as any);
    }

    getReceipt(receiptId: number): Observable<ApiResponseOfOrderDto> {
        let url_ = this.baseUrl + "/api/orders/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOrderDto>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ApiResponseOfOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOrderDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOrderDto>(null as any);
    }

    updateReceipt(receiptId: number, dto: OrderVersionDto): Observable<ApiResponseOfOrderVersionDto> {
        let url_ = this.baseUrl + "/api/orders/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOrderVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOrderVersionDto>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<ApiResponseOfOrderVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOrderVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOrderVersionDto>(null as any);
    }

    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfOrderPositionDto> {
        let url_ = this.baseUrl + "/api/orders/{receiptId}/calculatePositionDefaults";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePositionDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePositionDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOrderPositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOrderPositionDto>;
        }));
    }

    protected processCalculatePositionDefaults(response: HttpResponseBase): Observable<ApiResponseOfOrderPositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOrderPositionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOrderPositionDto>(null as any);
    }

    updateStatus(updateDto: ReceiptStatusUpdateDtoOfOrderDtoAndOrderStatusDto): Observable<ApiResponseOfListOfOrderVersionDto> {
        let url_ = this.baseUrl + "/api/orders/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfOrderVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfOrderVersionDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfOrderVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfOrderVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfOrderVersionDto>(null as any);
    }
}

export interface IOrderStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderStatusApiService implements IOrderStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/OrderStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface IOrderTransferApiService {
    transferToInvoice(orderId: number, dto: TransferOrderDto): Observable<ApiResponseOfInvoiceDto>;
    transferToDeliveryNote(orderId: number, dto: DeliveryNoteDownloadOptionsDto): Observable<ApiResponseOfDeliveryNoteDto>;
    getTransferredInvoices(orderId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
    getTransferredDeliveryNotes(orderId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderTransferApiService implements IOrderTransferApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    transferToInvoice(orderId: number, dto: TransferOrderDto): Observable<ApiResponseOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/transfer/invoice";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferToInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferToInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceDto>;
        }));
    }

    protected processTransferToInvoice(response: HttpResponseBase): Observable<ApiResponseOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceDto>(null as any);
    }

    transferToDeliveryNote(orderId: number, dto: DeliveryNoteDownloadOptionsDto): Observable<ApiResponseOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/transfer/deliveryNote";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferToDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferToDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteDto>;
        }));
    }

    protected processTransferToDeliveryNote(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteDto>(null as any);
    }

    getTransferredInvoices(orderId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/transferredInvoices?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferredInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferredInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
        }));
    }

    protected processGetTransferredInvoices(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfInvoiceDto>(null as any);
    }

    getTransferredDeliveryNotes(orderId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/orders/{orderId}/transferredDeliveryNotes?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferredDeliveryNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferredDeliveryNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
        }));
    }

    protected processGetTransferredDeliveryNotes(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteDto>(null as any);
    }
}

export interface IOrderVersionsApiService {
    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfOrderVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OrderVersionsApiService implements IOrderVersionsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfOrderVersionDto> {
        let url_ = this.baseUrl + "/api/orders/{receiptId}/versions?";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceiptVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceiptVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfOrderVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfOrderVersionDto>;
        }));
    }

    protected processGetPagedReceiptVersions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfOrderVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfOrderVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfOrderVersionDto>(null as any);
    }
}

export interface IOfferKindsApiService {
    getKinds(): Observable<ApiResponseOfListOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class OfferKindsApiService implements IOfferKindsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getKinds(): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/offers/kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }
}

export interface IOffersApiService {
    createFromConstructionProject(dto: CreateOfferConstructionProjectDto): Observable<ApiResponseOfOfferDto>;
    createFromCustomer(dto: CreateOfferCustomerDto): Observable<ApiResponseOfOfferDto>;
    updateReceipt(receiptId: number, dto: OfferVersionDto): Observable<ApiResponseOfOfferVersionDto>;
    getReceipt(receiptId: number): Observable<ApiResponseOfOfferDto>;
    recalculateOffer(offerId: number, recalculateDto: RecalculateOfferDto): Observable<ApiResponseOfOfferDto>;
    transferReceipt(offerId: number, dto: TransferOfferDto): Observable<ApiResponseOfOrderDto>;
    getTransferredOrders(offerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOrderDto>;
    requestReportDownload(offerId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    addMovePosition(dto: AddMovePositionDto, offerId: number): Observable<ApiResponseOfOfferVersionDto>;
    addCustomCosts(dto: OfferCustomCostsDto, offerId: number): Observable<ApiResponseOfOfferVersionDto>;
    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOfferDto>;
    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfOfferPositionDto>;
    updateStatus(updateDto: ReceiptStatusUpdateDtoOfOfferDtoAndOfferStatusDto): Observable<ApiResponseOfListOfOfferVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OffersApiService implements IOffersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    createFromConstructionProject(dto: CreateOfferConstructionProjectDto): Observable<ApiResponseOfOfferDto> {
        let url_ = this.baseUrl + "/api/offers/fromConstructionProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromConstructionProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromConstructionProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferDto>;
        }));
    }

    protected processCreateFromConstructionProject(response: HttpResponseBase): Observable<ApiResponseOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferDto>(null as any);
    }

    createFromCustomer(dto: CreateOfferCustomerDto): Observable<ApiResponseOfOfferDto> {
        let url_ = this.baseUrl + "/api/offers/fromCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFromCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFromCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferDto>;
        }));
    }

    protected processCreateFromCustomer(response: HttpResponseBase): Observable<ApiResponseOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferDto>(null as any);
    }

    updateReceipt(receiptId: number, dto: OfferVersionDto): Observable<ApiResponseOfOfferVersionDto> {
        let url_ = this.baseUrl + "/api/offers/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferVersionDto>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<ApiResponseOfOfferVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferVersionDto>(null as any);
    }

    getReceipt(receiptId: number): Observable<ApiResponseOfOfferDto> {
        let url_ = this.baseUrl + "/api/offers/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferDto>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ApiResponseOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferDto>(null as any);
    }

    recalculateOffer(offerId: number, recalculateDto: RecalculateOfferDto): Observable<ApiResponseOfOfferDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/recalculate";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recalculateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecalculateOffer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecalculateOffer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferDto>;
        }));
    }

    protected processRecalculateOffer(response: HttpResponseBase): Observable<ApiResponseOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferDto>(null as any);
    }

    transferReceipt(offerId: number, dto: TransferOfferDto): Observable<ApiResponseOfOrderDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/transfer";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOrderDto>;
        }));
    }

    protected processTransferReceipt(response: HttpResponseBase): Observable<ApiResponseOfOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOrderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOrderDto>(null as any);
    }

    getTransferredOrders(offerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOrderDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/transfer?";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferredOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferredOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfOrderDto>;
        }));
    }

    protected processGetTransferredOrders(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfOrderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfOrderDto>(null as any);
    }

    requestReportDownload(offerId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/downloadReport?";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        if (documentMode === null)
            throw new Error("The parameter 'documentMode' cannot be null.");
        else if (documentMode !== undefined)
            url_ += "documentMode=" + encodeURIComponent("" + documentMode) + "&";
        if (attachAgb === null)
            throw new Error("The parameter 'attachAgb' cannot be null.");
        else if (attachAgb !== undefined)
            url_ += "attachAgb=" + encodeURIComponent("" + attachAgb) + "&";
        if (attachImportantNotes === null)
            throw new Error("The parameter 'attachImportantNotes' cannot be null.");
        else if (attachImportantNotes !== undefined)
            url_ += "attachImportantNotes=" + encodeURIComponent("" + attachImportantNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/offers/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addMovePosition(dto: AddMovePositionDto, offerId: number): Observable<ApiResponseOfOfferVersionDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/movePosition";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMovePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMovePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferVersionDto>;
        }));
    }

    protected processAddMovePosition(response: HttpResponseBase): Observable<ApiResponseOfOfferVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferVersionDto>(null as any);
    }

    addCustomCosts(dto: OfferCustomCostsDto, offerId: number): Observable<ApiResponseOfOfferVersionDto> {
        let url_ = this.baseUrl + "/api/offers/{offerId}/customCosts";
        if (offerId === undefined || offerId === null)
            throw new Error("The parameter 'offerId' must be defined.");
        url_ = url_.replace("{offerId}", encodeURIComponent("" + offerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCustomCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCustomCosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferVersionDto>;
        }));
    }

    protected processAddCustomCosts(response: HttpResponseBase): Observable<ApiResponseOfOfferVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferVersionDto>(null as any);
    }

    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfOfferDto> {
        let url_ = this.baseUrl + "/api/offers?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfOfferDto>;
        }));
    }

    protected processGetPagedReceipts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfOfferDto>(null as any);
    }

    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfOfferPositionDto> {
        let url_ = this.baseUrl + "/api/offers/{receiptId}/calculatePositionDefaults";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePositionDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePositionDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfOfferPositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfOfferPositionDto>;
        }));
    }

    protected processCalculatePositionDefaults(response: HttpResponseBase): Observable<ApiResponseOfOfferPositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfOfferPositionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfOfferPositionDto>(null as any);
    }

    updateStatus(updateDto: ReceiptStatusUpdateDtoOfOfferDtoAndOfferStatusDto): Observable<ApiResponseOfListOfOfferVersionDto> {
        let url_ = this.baseUrl + "/api/offers/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfOfferVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfOfferVersionDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfOfferVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfOfferVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfOfferVersionDto>(null as any);
    }
}

export interface IOfferStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OfferStatusApiService implements IOfferStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/offers/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface IOfferVersionsApiService {
    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfOfferVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class OfferVersionsApiService implements IOfferVersionsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfOfferVersionDto> {
        let url_ = this.baseUrl + "/api/offers/{receiptId}/versions?";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceiptVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceiptVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfOfferVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfOfferVersionDto>;
        }));
    }

    protected processGetPagedReceiptVersions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfOfferVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfOfferVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfOfferVersionDto>(null as any);
    }
}

export interface IInvoiceKindsApiService {
    getKinds(): Observable<ApiResponseOfListOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceKindsApiService implements IInvoiceKindsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getKinds(): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/invoices/kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }
}

export interface IInvoicePaymentsApiService {
    loadByInvoiceId(invoiceId?: number | undefined): Observable<ApiResponseOfListOfInvoicePaymentDto>;
    createPayments(createDtos: InvoicePaymentCreateDto[]): Observable<ApiResponseOfInvoicePaymentDto>;
    createPayment(createDto: InvoicePaymentCreateDto): Observable<ApiResponseOfInvoicePaymentDto>;
    deletePayment(id: number): Observable<ApiResponseOfInvoicePaymentDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoicePaymentsApiService implements IInvoicePaymentsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    loadByInvoiceId(invoiceId?: number | undefined): Observable<ApiResponseOfListOfInvoicePaymentDto> {
        let url_ = this.baseUrl + "/api/InvoicePayments/loadByInvoice?";
        if (invoiceId === null)
            throw new Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadByInvoiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadByInvoiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfInvoicePaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfInvoicePaymentDto>;
        }));
    }

    protected processLoadByInvoiceId(response: HttpResponseBase): Observable<ApiResponseOfListOfInvoicePaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfInvoicePaymentDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfInvoicePaymentDto>(null as any);
    }

    createPayments(createDtos: InvoicePaymentCreateDto[]): Observable<ApiResponseOfInvoicePaymentDto> {
        let url_ = this.baseUrl + "/api/InvoicePayments/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDtos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoicePaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoicePaymentDto>;
        }));
    }

    protected processCreatePayments(response: HttpResponseBase): Observable<ApiResponseOfInvoicePaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoicePaymentDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoicePaymentDto>(null as any);
    }

    createPayment(createDto: InvoicePaymentCreateDto): Observable<ApiResponseOfInvoicePaymentDto> {
        let url_ = this.baseUrl + "/api/InvoicePayments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoicePaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoicePaymentDto>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<ApiResponseOfInvoicePaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoicePaymentDto;
            return _observableOf(result200);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoicePaymentDto>(null as any);
    }

    deletePayment(id: number): Observable<ApiResponseOfInvoicePaymentDto> {
        let url_ = this.baseUrl + "/api/InvoicePayments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoicePaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoicePaymentDto>;
        }));
    }

    protected processDeletePayment(response: HttpResponseBase): Observable<ApiResponseOfInvoicePaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoicePaymentDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoicePaymentDto>(null as any);
    }
}

export interface IInvoicesApiService {
    getTransferredCreditNotes(invoiceId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
    transferReceipt(transferDto: TransferInvoiceDto, invoiceId: number): Observable<ApiResponseOfCreditNoteDto>;
    release(invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    requestReportDownload(invoiceId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    addUnsuccessfullDeliveryPositions(dto: AddUnsuccessfullDeliveryPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    addWaitingTimePosition(dto: AddWaitingTimePositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    addRollingPosition(dto: AddRollingPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    addCleaningPosition(dto: AddCleaningPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    updateReleasedReceipt(invoiceId: number, data: ReceiptSystemPropertiesDtoOfInvoiceStatusDto): Observable<ApiResponseOfInvoiceVersionDto>;
    addMovePosition(dto: AddMovePositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto>;
    addTheftProtection(invoiceId: number, addTheftProtectionPositionDto: AddTheftProtectionPositionDto): Observable<ApiResponseOfInvoiceDto>;
    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
    getReceipt(receiptId: number): Observable<ApiResponseOfInvoiceDto>;
    updateReceipt(receiptId: number, dto: InvoiceVersionDto): Observable<ApiResponseOfInvoiceVersionDto>;
    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfInvoicePositionDto>;
    updateStatus(updateDto: ReceiptStatusUpdateDtoOfInvoiceDtoAndInvoiceStatusDto): Observable<ApiResponseOfListOfInvoiceVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoicesApiService implements IInvoicesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getTransferredCreditNotes(invoiceId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/transfer?";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransferredCreditNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransferredCreditNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
        }));
    }

    protected processGetTransferredCreditNotes(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCreditNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCreditNoteDto>(null as any);
    }

    transferReceipt(transferDto: TransferInvoiceDto, invoiceId: number): Observable<ApiResponseOfCreditNoteDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/transfer";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNoteDto>;
        }));
    }

    protected processTransferReceipt(response: HttpResponseBase): Observable<ApiResponseOfCreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNoteDto>(null as any);
    }

    release(invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/release";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processRelease(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    requestReportDownload(invoiceId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/downloadReport?";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (documentMode === null)
            throw new Error("The parameter 'documentMode' cannot be null.");
        else if (documentMode !== undefined)
            url_ += "documentMode=" + encodeURIComponent("" + documentMode) + "&";
        if (attachAgb === null)
            throw new Error("The parameter 'attachAgb' cannot be null.");
        else if (attachAgb !== undefined)
            url_ += "attachAgb=" + encodeURIComponent("" + attachAgb) + "&";
        if (attachImportantNotes === null)
            throw new Error("The parameter 'attachImportantNotes' cannot be null.");
        else if (attachImportantNotes !== undefined)
            url_ += "attachImportantNotes=" + encodeURIComponent("" + attachImportantNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/invoices/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    addUnsuccessfullDeliveryPositions(dto: AddUnsuccessfullDeliveryPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/unsuccessfullDeliveryPositions";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUnsuccessfullDeliveryPositions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUnsuccessfullDeliveryPositions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processAddUnsuccessfullDeliveryPositions(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    addWaitingTimePosition(dto: AddWaitingTimePositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/waitingTimePosition";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWaitingTimePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWaitingTimePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processAddWaitingTimePosition(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    addRollingPosition(dto: AddRollingPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/rollingPosition";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRollingPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRollingPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processAddRollingPosition(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    addCleaningPosition(dto: AddCleaningPositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/cleaningPosition";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCleaningPosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCleaningPosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processAddCleaningPosition(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    updateReleasedReceipt(invoiceId: number, data: ReceiptSystemPropertiesDtoOfInvoiceStatusDto): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/data";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReleasedReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReleasedReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processUpdateReleasedReceipt(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    addMovePosition(dto: AddMovePositionDto, invoiceId: number): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/movePosition";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddMovePosition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddMovePosition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processAddMovePosition(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    addTheftProtection(invoiceId: number, addTheftProtectionPositionDto: AddTheftProtectionPositionDto): Observable<ApiResponseOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{invoiceId}/theftProtectionPosition";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addTheftProtectionPositionDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddTheftProtection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddTheftProtection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceDto>;
        }));
    }

    protected processAddTheftProtection(response: HttpResponseBase): Observable<ApiResponseOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceDto>(null as any);
    }

    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfInvoiceDto>;
        }));
    }

    protected processGetPagedReceipts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfInvoiceDto>(null as any);
    }

    getReceipt(receiptId: number): Observable<ApiResponseOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/invoices/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceDto>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ApiResponseOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceDto>(null as any);
    }

    updateReceipt(receiptId: number, dto: InvoiceVersionDto): Observable<ApiResponseOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoiceVersionDto>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<ApiResponseOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoiceVersionDto>(null as any);
    }

    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfInvoicePositionDto> {
        let url_ = this.baseUrl + "/api/invoices/{receiptId}/calculatePositionDefaults";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePositionDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePositionDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfInvoicePositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfInvoicePositionDto>;
        }));
    }

    protected processCalculatePositionDefaults(response: HttpResponseBase): Observable<ApiResponseOfInvoicePositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfInvoicePositionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfInvoicePositionDto>(null as any);
    }

    updateStatus(updateDto: ReceiptStatusUpdateDtoOfInvoiceDtoAndInvoiceStatusDto): Observable<ApiResponseOfListOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfInvoiceVersionDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfInvoiceVersionDto>(null as any);
    }
}

export interface IInvoiceStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceStatusApiService implements IInvoiceStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/InvoiceStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface IInvoiceVersionsApiService {
    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceVersionsApiService implements IInvoiceVersionsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfInvoiceVersionDto> {
        let url_ = this.baseUrl + "/api/invoices/{receiptId}/versions?";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceiptVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceiptVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfInvoiceVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfInvoiceVersionDto>;
        }));
    }

    protected processGetPagedReceiptVersions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfInvoiceVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfInvoiceVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfInvoiceVersionDto>(null as any);
    }
}

export interface IDeliveryNoteAssignmentApiService {
    getPagedDeliveryNoteAssignments(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto>;
    createAssignment(dto: DeliveryNoteAssignmentDto): Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
    deleteBulkAssignments(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto>;
    getDeliveryNoteAssignment(id: number): Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
    updateAssignment(id: number, dto: DeliveryNoteAssignmentDto): Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
    deleteAssignment(id: number): Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
    getAllByVehicleAndDate(vehicleId?: number | undefined, date?: string | undefined): Observable<ApiResponseOfIListOfDeliveryNoteAssignmentDto>;
    generateMail(deliveryNoteAssignmentIds: number[]): Observable<ApiResponseOfMailDataDto>;
    sendMail(mailData: MailDataDto): Observable<void>;
    requestMailDownload(deliveryNoteAssignmentIds: number[]): Observable<ApiResponseOfDownloadReportDto>;
    downloadMail(token?: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteAssignmentApiService implements IDeliveryNoteAssignmentApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedDeliveryNoteAssignments(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedDeliveryNoteAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedDeliveryNoteAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processGetPagedDeliveryNoteAssignments(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto>(null as any);
    }

    createAssignment(dto: DeliveryNoteAssignmentDto): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processCreateAssignment(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteAssignmentDto>(null as any);
    }

    deleteBulkAssignments(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkAssignments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkAssignments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processDeleteBulkAssignments(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto>(null as any);
    }

    getDeliveryNoteAssignment(id: number): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryNoteAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryNoteAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processGetDeliveryNoteAssignment(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteAssignmentDto>(null as any);
    }

    updateAssignment(id: number, dto: DeliveryNoteAssignmentDto): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processUpdateAssignment(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteAssignmentDto>(null as any);
    }

    deleteAssignment(id: number): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processDeleteAssignment(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteAssignmentDto>(null as any);
    }

    getAllByVehicleAndDate(vehicleId?: number | undefined, date?: string | undefined): Observable<ApiResponseOfIListOfDeliveryNoteAssignmentDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/byVehicle?";
        if (vehicleId === null)
            throw new Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByVehicleAndDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByVehicleAndDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfDeliveryNoteAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfDeliveryNoteAssignmentDto>;
        }));
    }

    protected processGetAllByVehicleAndDate(response: HttpResponseBase): Observable<ApiResponseOfIListOfDeliveryNoteAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIListOfDeliveryNoteAssignmentDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIListOfDeliveryNoteAssignmentDto>(null as any);
    }

    generateMail(deliveryNoteAssignmentIds: number[]): Observable<ApiResponseOfMailDataDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/generateMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryNoteAssignmentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfMailDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfMailDataDto>;
        }));
    }

    protected processGenerateMail(response: HttpResponseBase): Observable<ApiResponseOfMailDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfMailDataDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfMailDataDto>(null as any);
    }

    sendMail(mailData: MailDataDto): Observable<void> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/sendMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(mailData);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendMail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    requestMailDownload(deliveryNoteAssignmentIds: number[]): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/requestMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deliveryNoteAssignmentIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestMailDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestMailDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestMailDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadMail(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deliveryNotes/assignments/downloadMail?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadMail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IDeliveryNoteApiService {
    deleteDeliveryNote(id: number): Observable<ApiResponseOfDeliveryNoteDto>;
    requestReportDownload(deliveryNoteId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    getBacklog(customerId?: number[] | null | undefined, constructionProjectId?: number | null | undefined, kind?: string | null | undefined, statusId?: number | null | undefined, articleId?: number | null | undefined, deliveryDateFrom?: string | null | undefined, deliveryDateTo?: string | null | undefined, zipCodeFrom?: string | null | undefined, zipCodeTo?: string | null | undefined, articleCountFrom?: number | null | undefined, articleCountTo?: number | null | undefined, fromItemId?: number | null | undefined, take?: number | undefined): Observable<ApiSeekPaginationResponseOfDeliveryNoteDto>;
    loadUnprocessed(constructionProjectId?: number | undefined, ignoredInvoiceId?: number | null | undefined): Observable<ApiResponseOfIListOfDeliveryNoteDto>;
    getDeliveryNotesByOrderId(orderId: number): Observable<DeliveryNoteDto[]>;
    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
    getReceipt(receiptId: number): Observable<ApiResponseOfDeliveryNoteDto>;
    updateReceipt(receiptId: number, dto: DeliveryNoteVersionDto): Observable<ApiResponseOfDeliveryNoteVersionDto>;
    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfDeliveryNotePositionDto>;
    updateStatus(updateDto: ReceiptStatusUpdateDtoOfDeliveryNoteDtoAndDeliveryNoteStatusDto): Observable<ApiResponseOfListOfDeliveryNoteVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteApiService implements IDeliveryNoteApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    deleteDeliveryNote(id: number): Observable<ApiResponseOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteDto>;
        }));
    }

    protected processDeleteDeliveryNote(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteDto>(null as any);
    }

    requestReportDownload(deliveryNoteId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{deliveryNoteId}/downloadReport?";
        if (deliveryNoteId === undefined || deliveryNoteId === null)
            throw new Error("The parameter 'deliveryNoteId' must be defined.");
        url_ = url_.replace("{deliveryNoteId}", encodeURIComponent("" + deliveryNoteId));
        if (documentMode === null)
            throw new Error("The parameter 'documentMode' cannot be null.");
        else if (documentMode !== undefined)
            url_ += "documentMode=" + encodeURIComponent("" + documentMode) + "&";
        if (attachAgb === null)
            throw new Error("The parameter 'attachAgb' cannot be null.");
        else if (attachAgb !== undefined)
            url_ += "attachAgb=" + encodeURIComponent("" + attachAgb) + "&";
        if (attachImportantNotes === null)
            throw new Error("The parameter 'attachImportantNotes' cannot be null.");
        else if (attachImportantNotes !== undefined)
            url_ += "attachImportantNotes=" + encodeURIComponent("" + attachImportantNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deliveryNotes/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getBacklog(customerId?: number[] | null | undefined, constructionProjectId?: number | null | undefined, kind?: string | null | undefined, statusId?: number | null | undefined, articleId?: number | null | undefined, deliveryDateFrom?: string | null | undefined, deliveryDateTo?: string | null | undefined, zipCodeFrom?: string | null | undefined, zipCodeTo?: string | null | undefined, articleCountFrom?: number | null | undefined, articleCountTo?: number | null | undefined, fromItemId?: number | null | undefined, take?: number | undefined): Observable<ApiSeekPaginationResponseOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/unassigned?";
        if (customerId !== undefined && customerId !== null)
            customerId && customerId.forEach(item => { url_ += "customerId=" + encodeURIComponent("" + item) + "&"; });
        if (constructionProjectId !== undefined && constructionProjectId !== null)
            url_ += "constructionProjectId=" + encodeURIComponent("" + constructionProjectId) + "&";
        if (kind !== undefined && kind !== null)
            url_ += "kind=" + encodeURIComponent("" + kind) + "&";
        if (statusId !== undefined && statusId !== null)
            url_ += "statusId=" + encodeURIComponent("" + statusId) + "&";
        if (articleId !== undefined && articleId !== null)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        if (deliveryDateFrom !== undefined && deliveryDateFrom !== null)
            url_ += "deliveryDateFrom=" + encodeURIComponent("" + deliveryDateFrom) + "&";
        if (deliveryDateTo !== undefined && deliveryDateTo !== null)
            url_ += "deliveryDateTo=" + encodeURIComponent("" + deliveryDateTo) + "&";
        if (zipCodeFrom !== undefined && zipCodeFrom !== null)
            url_ += "zipCodeFrom=" + encodeURIComponent("" + zipCodeFrom) + "&";
        if (zipCodeTo !== undefined && zipCodeTo !== null)
            url_ += "zipCodeTo=" + encodeURIComponent("" + zipCodeTo) + "&";
        if (articleCountFrom !== undefined && articleCountFrom !== null)
            url_ += "articleCountFrom=" + encodeURIComponent("" + articleCountFrom) + "&";
        if (articleCountTo !== undefined && articleCountTo !== null)
            url_ += "articleCountTo=" + encodeURIComponent("" + articleCountTo) + "&";
        if (fromItemId !== undefined && fromItemId !== null)
            url_ += "fromItemId=" + encodeURIComponent("" + fromItemId) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBacklog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBacklog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiSeekPaginationResponseOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiSeekPaginationResponseOfDeliveryNoteDto>;
        }));
    }

    protected processGetBacklog(response: HttpResponseBase): Observable<ApiSeekPaginationResponseOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiSeekPaginationResponseOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiSeekPaginationResponseOfDeliveryNoteDto>(null as any);
    }

    loadUnprocessed(constructionProjectId?: number | undefined, ignoredInvoiceId?: number | null | undefined): Observable<ApiResponseOfIListOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/unprocessed?";
        if (constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' cannot be null.");
        else if (constructionProjectId !== undefined)
            url_ += "constructionProjectId=" + encodeURIComponent("" + constructionProjectId) + "&";
        if (ignoredInvoiceId !== undefined && ignoredInvoiceId !== null)
            url_ += "ignoredInvoiceId=" + encodeURIComponent("" + ignoredInvoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadUnprocessed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadUnprocessed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIListOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIListOfDeliveryNoteDto>;
        }));
    }

    protected processLoadUnprocessed(response: HttpResponseBase): Observable<ApiResponseOfIListOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIListOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIListOfDeliveryNoteDto>(null as any);
    }

    getDeliveryNotesByOrderId(orderId: number): Observable<DeliveryNoteDto[]> {
        let url_ = this.baseUrl + "/api/deliveryNotes/byOrder/{orderId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryNotesByOrderId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryNotesByOrderId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryNoteDto[]>;
        }));
    }

    protected processGetDeliveryNotesByOrderId(response: HttpResponseBase): Observable<DeliveryNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryNoteDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryNoteDto[]>(null as any);
    }

    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto>;
        }));
    }

    protected processGetPagedReceipts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteDto>(null as any);
    }

    getReceipt(receiptId: number): Observable<ApiResponseOfDeliveryNoteDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteDto>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteDto>(null as any);
    }

    updateReceipt(receiptId: number, dto: DeliveryNoteVersionDto): Observable<ApiResponseOfDeliveryNoteVersionDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteVersionDto>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteVersionDto>(null as any);
    }

    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfDeliveryNotePositionDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{receiptId}/calculatePositionDefaults";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePositionDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePositionDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNotePositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNotePositionDto>;
        }));
    }

    protected processCalculatePositionDefaults(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNotePositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNotePositionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNotePositionDto>(null as any);
    }

    updateStatus(updateDto: ReceiptStatusUpdateDtoOfDeliveryNoteDtoAndDeliveryNoteStatusDto): Observable<ApiResponseOfListOfDeliveryNoteVersionDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfDeliveryNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfDeliveryNoteVersionDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfDeliveryNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfDeliveryNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfDeliveryNoteVersionDto>(null as any);
    }
}

export interface IDeliveryNoteReplyApiService {
    getNewForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    getDeliveryDatesOfRepliesForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto>;
    loadByDeliveryNote(deliveryNoteId?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
    getPagedDeliveryNoteReplies(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
    createDeliveryNoteReply(dto: DeliveryNoteReplyDto): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    updateDeliveryNoteReply(updateDto: DeliveryNoteReplyUpdateDto): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    deleteBulkDeliveryNoteReplies(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto>;
    getDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    deleteDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    updateDeliveryNoteReplyStatus(id: number, newStatusId?: number | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto>;
    requestReportDownload(deliveryNoteReplyId: number): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    getOpenDeliveryNoteRepliesByDeliveryNoteId(deliveryNoteId: number): Observable<DeliveryNoteReplyDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteReplyApiService implements IDeliveryNoteReplyApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getNewForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/new?";
        if (remoteAccessToken === null)
            throw new Error("The parameter 'remoteAccessToken' cannot be null.");
        else if (remoteAccessToken !== undefined)
            url_ += "remoteAccessToken=" + encodeURIComponent("" + remoteAccessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNewForDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNewForDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processGetNewForDeliveryNote(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    getDeliveryDatesOfRepliesForDeliveryNote(remoteAccessToken?: string | undefined): Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/deliveryDatesOfReplies?";
        if (remoteAccessToken === null)
            throw new Error("The parameter 'remoteAccessToken' cannot be null.");
        else if (remoteAccessToken !== undefined)
            url_ += "remoteAccessToken=" + encodeURIComponent("" + remoteAccessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryDatesOfRepliesForDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryDatesOfRepliesForDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto>;
        }));
    }

    protected processGetDeliveryDatesOfRepliesForDeliveryNote(response: HttpResponseBase): Observable<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto>(null as any);
    }

    loadByDeliveryNote(deliveryNoteId?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/byDeliveryNote?";
        if (deliveryNoteId === null)
            throw new Error("The parameter 'deliveryNoteId' cannot be null.");
        else if (deliveryNoteId !== undefined)
            url_ += "deliveryNoteId=" + encodeURIComponent("" + deliveryNoteId) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadByDeliveryNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadByDeliveryNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
        }));
    }

    protected processLoadByDeliveryNote(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>(null as any);
    }

    getPagedDeliveryNoteReplies(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedDeliveryNoteReplies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedDeliveryNoteReplies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>;
        }));
    }

    protected processGetPagedDeliveryNoteReplies(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteReplyDto>(null as any);
    }

    createDeliveryNoteReply(dto: DeliveryNoteReplyDto): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryNoteReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryNoteReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processCreateDeliveryNoteReply(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    updateDeliveryNoteReply(updateDto: DeliveryNoteReplyUpdateDto): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryNoteReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryNoteReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processUpdateDeliveryNoteReply(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    deleteBulkDeliveryNoteReplies(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkDeliveryNoteReplies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkDeliveryNoteReplies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processDeleteBulkDeliveryNoteReplies(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    getDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryNoteReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryNoteReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processGetDeliveryNoteReply(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    deleteDeliveryNoteReply(id: number): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryNoteReply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryNoteReply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processDeleteDeliveryNoteReply(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    updateDeliveryNoteReplyStatus(id: number, newStatusId?: number | undefined): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/{id}/updateStatus?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (newStatusId === null)
            throw new Error("The parameter 'newStatusId' cannot be null.");
        else if (newStatusId !== undefined)
            url_ += "newStatusId=" + encodeURIComponent("" + newStatusId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryNoteReplyStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryNoteReplyStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryNoteReplyDto>;
        }));
    }

    protected processUpdateDeliveryNoteReplyStatus(response: HttpResponseBase): Observable<ApiResponseOfDeliveryNoteReplyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryNoteReplyDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryNoteReplyDto>(null as any);
    }

    requestReportDownload(deliveryNoteReplyId: number): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/{deliveryNoteReplyId}/requestReport";
        if (deliveryNoteReplyId === undefined || deliveryNoteReplyId === null)
            throw new Error("The parameter 'deliveryNoteReplyId' must be defined.");
        url_ = url_.replace("{deliveryNoteReplyId}", encodeURIComponent("" + deliveryNoteReplyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getOpenDeliveryNoteRepliesByDeliveryNoteId(deliveryNoteId: number): Observable<DeliveryNoteReplyDto[]> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/open/byDeliveryNote/{deliveryNoteId}";
        if (deliveryNoteId === undefined || deliveryNoteId === null)
            throw new Error("The parameter 'deliveryNoteId' must be defined.");
        url_ = url_.replace("{deliveryNoteId}", encodeURIComponent("" + deliveryNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenDeliveryNoteRepliesByDeliveryNoteId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenDeliveryNoteRepliesByDeliveryNoteId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeliveryNoteReplyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeliveryNoteReplyDto[]>;
        }));
    }

    protected processGetOpenDeliveryNoteRepliesByDeliveryNoteId(response: HttpResponseBase): Observable<DeliveryNoteReplyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeliveryNoteReplyDto[];
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeliveryNoteReplyDto[]>(null as any);
    }
}

export interface IDeliveryNoteReplyStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteReplyStatusApiService implements IDeliveryNoteReplyStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/replies/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface IDeliveryNoteStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteStatusApiService implements IDeliveryNoteStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface IDeliveryNoteVersionApiService {
    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryNoteVersionApiService implements IDeliveryNoteVersionApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto> {
        let url_ = this.baseUrl + "/api/deliveryNotes/{receiptId}/versions?";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceiptVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceiptVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto>;
        }));
    }

    protected processGetPagedReceiptVersions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryNoteVersionDto>(null as any);
    }
}

export interface IDispositionMailDraftApiService {
    getAll(): Observable<ApiResponseOfListOfDispositionMailDraftListItemDto>;
    create(dto: DispositionMailDraftDto): Observable<ApiResponseOfDispositionMailDraftDto>;
    get(id: number): Observable<ApiResponseOfDispositionMailDraftDto>;
    update(id: number, dto: DispositionMailDraftDto): Observable<ApiResponseOfDispositionMailDraftDto>;
    delete(id: number): Observable<void>;
    send(id: number, dto: DispositionMailDraftDto): Observable<void>;
}

@Injectable({
    providedIn: 'root'
})
export class DispositionMailDraftApiService implements IDispositionMailDraftApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAll(): Observable<ApiResponseOfListOfDispositionMailDraftListItemDto> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfDispositionMailDraftListItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfDispositionMailDraftListItemDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ApiResponseOfListOfDispositionMailDraftListItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfDispositionMailDraftListItemDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfDispositionMailDraftListItemDto>(null as any);
    }

    create(dto: DispositionMailDraftDto): Observable<ApiResponseOfDispositionMailDraftDto> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ApiResponseOfDispositionMailDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDispositionMailDraftDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDispositionMailDraftDto>(null as any);
    }

    get(id: number): Observable<ApiResponseOfDispositionMailDraftDto> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiResponseOfDispositionMailDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDispositionMailDraftDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDispositionMailDraftDto>(null as any);
    }

    update(id: number, dto: DispositionMailDraftDto): Observable<ApiResponseOfDispositionMailDraftDto> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDispositionMailDraftDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ApiResponseOfDispositionMailDraftDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDispositionMailDraftDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDispositionMailDraftDto>(null as any);
    }

    delete(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    send(id: number, dto: DispositionMailDraftDto): Observable<void> {
        let url_ = this.baseUrl + "/api/dispositionMailDrafts/{id}/send";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export interface ICreditNoteKindsApiService {
    getKinds(): Observable<ApiResponseOfListOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class CreditNoteKindsApiService implements ICreditNoteKindsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getKinds(): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/creditNotes/kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }
}

export interface ICreditNotesApiService {
    release(creditNoteId: number): Observable<ApiResponseOfCreditNoteVersionDto>;
    requestReportDownload(creditNoteId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto>;
    downloadReport(token?: string | undefined): Observable<FileResponse>;
    updateReleasedReceipt(creditNoteId: number, data: ReceiptSystemPropertiesDtoOfCreditNoteStatusDto): Observable<ApiResponseOfCreditNoteVersionDto>;
    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
    getReceipt(receiptId: number): Observable<ApiResponseOfCreditNoteDto>;
    updateReceipt(receiptId: number, dto: CreditNoteVersionDto): Observable<ApiResponseOfCreditNoteVersionDto>;
    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfCreditNotePositionDto>;
    updateStatus(updateDto: ReceiptStatusUpdateDtoOfCreditNoteDtoAndCreditNoteStatusDto): Observable<ApiResponseOfListOfCreditNoteVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CreditNotesApiService implements ICreditNotesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    release(creditNoteId: number): Observable<ApiResponseOfCreditNoteVersionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{creditNoteId}/release";
        if (creditNoteId === undefined || creditNoteId === null)
            throw new Error("The parameter 'creditNoteId' must be defined.");
        url_ = url_.replace("{creditNoteId}", encodeURIComponent("" + creditNoteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
        }));
    }

    protected processRelease(response: HttpResponseBase): Observable<ApiResponseOfCreditNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNoteVersionDto>(null as any);
    }

    requestReportDownload(creditNoteId: number, documentMode?: ReportMode | undefined, attachAgb?: boolean | undefined, attachImportantNotes?: boolean | undefined): Observable<ApiResponseOfDownloadReportDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{creditNoteId}/downloadReport?";
        if (creditNoteId === undefined || creditNoteId === null)
            throw new Error("The parameter 'creditNoteId' must be defined.");
        url_ = url_.replace("{creditNoteId}", encodeURIComponent("" + creditNoteId));
        if (documentMode === null)
            throw new Error("The parameter 'documentMode' cannot be null.");
        else if (documentMode !== undefined)
            url_ += "documentMode=" + encodeURIComponent("" + documentMode) + "&";
        if (attachAgb === null)
            throw new Error("The parameter 'attachAgb' cannot be null.");
        else if (attachAgb !== undefined)
            url_ += "attachAgb=" + encodeURIComponent("" + attachAgb) + "&";
        if (attachImportantNotes === null)
            throw new Error("The parameter 'attachImportantNotes' cannot be null.");
        else if (attachImportantNotes !== undefined)
            url_ += "attachImportantNotes=" + encodeURIComponent("" + attachImportantNotes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestReportDownload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestReportDownload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDownloadReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDownloadReportDto>;
        }));
    }

    protected processRequestReportDownload(response: HttpResponseBase): Observable<ApiResponseOfDownloadReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDownloadReportDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDownloadReportDto>(null as any);
    }

    downloadReport(token?: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/creditNotes/downloadReport?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadReport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateReleasedReceipt(creditNoteId: number, data: ReceiptSystemPropertiesDtoOfCreditNoteStatusDto): Observable<ApiResponseOfCreditNoteVersionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{creditNoteId}/data";
        if (creditNoteId === undefined || creditNoteId === null)
            throw new Error("The parameter 'creditNoteId' must be defined.");
        url_ = url_.replace("{creditNoteId}", encodeURIComponent("" + creditNoteId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReleasedReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReleasedReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
        }));
    }

    protected processUpdateReleasedReceipt(response: HttpResponseBase): Observable<ApiResponseOfCreditNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNoteVersionDto>(null as any);
    }

    getPagedReceipts(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteDto> {
        let url_ = this.baseUrl + "/api/creditNotes?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceipts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceipts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteDto>;
        }));
    }

    protected processGetPagedReceipts(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCreditNoteDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCreditNoteDto>(null as any);
    }

    getReceipt(receiptId: number): Observable<ApiResponseOfCreditNoteDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNoteDto>;
        }));
    }

    protected processGetReceipt(response: HttpResponseBase): Observable<ApiResponseOfCreditNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNoteDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNoteDto>(null as any);
    }

    updateReceipt(receiptId: number, dto: CreditNoteVersionDto): Observable<ApiResponseOfCreditNoteVersionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{receiptId}";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNoteVersionDto>;
        }));
    }

    protected processUpdateReceipt(response: HttpResponseBase): Observable<ApiResponseOfCreditNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNoteVersionDto>(null as any);
    }

    calculatePositionDefaults(receiptId: number, dto: DefaultPositionCalculationDto): Observable<ApiResponseOfCreditNotePositionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{receiptId}/calculatePositionDefaults";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculatePositionDefaults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculatePositionDefaults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCreditNotePositionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCreditNotePositionDto>;
        }));
    }

    protected processCalculatePositionDefaults(response: HttpResponseBase): Observable<ApiResponseOfCreditNotePositionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCreditNotePositionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCreditNotePositionDto>(null as any);
    }

    updateStatus(updateDto: ReceiptStatusUpdateDtoOfCreditNoteDtoAndCreditNoteStatusDto): Observable<ApiResponseOfListOfCreditNoteVersionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/updateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfCreditNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfCreditNoteVersionDto>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfCreditNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfCreditNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfCreditNoteVersionDto>(null as any);
    }
}

export interface ICreditNotesStatusApiService {
    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CreditNotesStatusApiService implements ICreditNotesStatusApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllStatus(): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        let url_ = this.baseUrl + "/api/CreditNotesStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfBaseReceiptStatusDto>;
        }));
    }

    protected processGetAllStatus(response: HttpResponseBase): Observable<ApiResponseOfListOfBaseReceiptStatusDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfBaseReceiptStatusDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfBaseReceiptStatusDto>(null as any);
    }
}

export interface ICreditNoteVersionsApiService {
    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteVersionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CreditNoteVersionsApiService implements ICreditNoteVersionsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedReceiptVersions(receiptId: number, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfCreditNoteVersionDto> {
        let url_ = this.baseUrl + "/api/creditNotes/{receiptId}/versions?";
        if (receiptId === undefined || receiptId === null)
            throw new Error("The parameter 'receiptId' must be defined.");
        url_ = url_.replace("{receiptId}", encodeURIComponent("" + receiptId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedReceiptVersions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedReceiptVersions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCreditNoteVersionDto>;
        }));
    }

    protected processGetPagedReceiptVersions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCreditNoteVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCreditNoteVersionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCreditNoteVersionDto>(null as any);
    }
}

export interface IReceiptKindsApiService {
    getKinds(): Observable<ApiResponseOfListOfString>;
}

@Injectable({
    providedIn: 'root'
})
export class ReceiptKindsApiService implements IReceiptKindsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getKinds(): Observable<ApiResponseOfListOfString> {
        let url_ = this.baseUrl + "/api/ReceiptKinds/kinds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetKinds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetKinds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfString>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfString>;
        }));
    }

    protected processGetKinds(response: HttpResponseBase): Observable<ApiResponseOfListOfString> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfString;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfString>(null as any);
    }
}

export interface IRapsApiService {
    getPagedRaps(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfRapDto>;
    createRap(dto: RapDto): Observable<ApiResponseOfRapDto>;
    deleteBulkRaps(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfRapDto>;
    getOpenPagesRaps(loadOpenRapsOnly?: boolean | undefined, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfRapDto>;
    getRap(id: number): Observable<ApiResponseOfRapDto>;
    updateRap(id: number, dto: RapDto): Observable<ApiResponseOfRapDto>;
    deleteRap(id: number): Observable<ApiResponseOfRapDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RapsApiService implements IRapsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedRaps(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedRaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedRaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfRapDto>;
        }));
    }

    protected processGetPagedRaps(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfRapDto>(null as any);
    }

    createRap(dto: RapDto): Observable<ApiResponseOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRapDto>;
        }));
    }

    protected processCreateRap(response: HttpResponseBase): Observable<ApiResponseOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRapDto>(null as any);
    }

    deleteBulkRaps(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkRaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkRaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfRapDto>;
        }));
    }

    protected processDeleteBulkRaps(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfRapDto>(null as any);
    }

    getOpenPagesRaps(loadOpenRapsOnly?: boolean | undefined, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps/open?";
        if (loadOpenRapsOnly === null)
            throw new Error("The parameter 'loadOpenRapsOnly' cannot be null.");
        else if (loadOpenRapsOnly !== undefined)
            url_ += "loadOpenRapsOnly=" + encodeURIComponent("" + loadOpenRapsOnly) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOpenPagesRaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOpenPagesRaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfRapDto>;
        }));
    }

    protected processGetOpenPagesRaps(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfRapDto>(null as any);
    }

    getRap(id: number): Observable<ApiResponseOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRapDto>;
        }));
    }

    protected processGetRap(response: HttpResponseBase): Observable<ApiResponseOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRapDto>(null as any);
    }

    updateRap(id: number, dto: RapDto): Observable<ApiResponseOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRapDto>;
        }));
    }

    protected processUpdateRap(response: HttpResponseBase): Observable<ApiResponseOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRapDto>(null as any);
    }

    deleteRap(id: number): Observable<ApiResponseOfRapDto> {
        let url_ = this.baseUrl + "/api/Raps/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRapDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRapDto>;
        }));
    }

    protected processDeleteRap(response: HttpResponseBase): Observable<ApiResponseOfRapDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRapDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRapDto>(null as any);
    }
}

export interface ICountriesApiService {
    getPagedCountries(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCountryDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CountriesApiService implements ICountriesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedCountries(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCountryDto> {
        let url_ = this.baseUrl + "/api/countries?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCountryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCountryDto>;
        }));
    }

    protected processGetPagedCountries(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCountryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCountryDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCountryDto>(null as any);
    }
}

export interface ICustomerConstructionProjectsApiService {
    getPagedConstructionProjects(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerConstructionProjectsApiService implements ICustomerConstructionProjectsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedConstructionProjects(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/constructionProjects?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedConstructionProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedConstructionProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
        }));
    }

    protected processGetPagedConstructionProjects(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfConstructionProjectDto>(null as any);
    }
}

export interface ICustomerContactPersonsApiService {
    getPagedContactPersons(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
    deleteBulkContactPersons(customerId: number, contactPersonId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
    createContactPerson(customerId: number, contactPersonId: number): Observable<ApiResponseOfCustomerContactPersonDto>;
    deleteContactPerson(customerId: number, contactPersonId: number): Observable<ApiResponseOfCustomerContactPersonDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerContactPersonsApiService implements ICustomerContactPersonsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedContactPersons(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/contactPersons?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
        }));
    }

    protected processGetPagedContactPersons(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContactPersonDto>(null as any);
    }

    deleteBulkContactPersons(customerId: number, contactPersonId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/contactPersons?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' cannot be null.");
        else if (contactPersonId !== undefined)
            contactPersonId && contactPersonId.forEach(item => { url_ += "contactPersonId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processDeleteBulkContactPersons(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>(null as any);
    }

    createContactPerson(customerId: number, contactPersonId: number): Observable<ApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/contactPersons/{contactPersonId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processCreateContactPerson(response: HttpResponseBase): Observable<ApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerContactPersonDto>(null as any);
    }

    deleteContactPerson(customerId: number, contactPersonId: number): Observable<ApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/contactPersons/{contactPersonId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processDeleteContactPerson(response: HttpResponseBase): Observable<ApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerContactPersonDto>(null as any);
    }
}

export interface ICustomersApiService {
    getPagedCustomers(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto>;
    createCustomer(dto: CustomerDto): Observable<ApiResponseOfCustomerDto>;
    deleteBulkCustomers(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
    getPagedCustomersByInactiveState(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined, isInactive?: boolean | null | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto>;
    getCustomer(id: number): Observable<ApiResponseOfCustomerDto>;
    updateCustomer(id: number, dto: CustomerDto): Observable<ApiResponseOfCustomerDto>;
    deleteCustomer(id: number): Observable<ApiResponseOfCustomerDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomersApiService implements ICustomersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedCustomers(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
        }));
    }

    protected processGetPagedCustomers(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCustomerDto>(null as any);
    }

    createCustomer(dto: CustomerDto): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processCreateCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }

    deleteBulkCustomers(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
        }));
    }

    protected processDeleteBulkCustomers(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfCustomerDto>(null as any);
    }

    getPagedCustomersByInactiveState(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined, isInactive?: boolean | null | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers/inactive?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (isInactive !== undefined && isInactive !== null)
            url_ += "isInactive=" + encodeURIComponent("" + isInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedCustomersByInactiveState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedCustomersByInactiveState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
        }));
    }

    protected processGetPagedCustomersByInactiveState(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCustomerDto>(null as any);
    }

    getCustomer(id: number): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }

    updateCustomer(id: number, dto: CustomerDto): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processUpdateCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }

    deleteCustomer(id: number): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }
}

export interface ICustomerSubCustomersApiService {
    getPagedSubCustomers(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto>;
    deleteBulkSubCustomers(customerId: number, subCustomerId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
    createSubCustomer(customerId: number, subCustomerId: number): Observable<ApiResponseOfCustomerDto>;
    deleteSubCustomer(customerId: number, subCustomerId: number): Observable<ApiResponseOfCustomerDto>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerSubCustomersApiService implements ICustomerSubCustomersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedSubCustomers(customerId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/subCustomers?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedSubCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedSubCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
        }));
    }

    protected processGetPagedSubCustomers(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCustomerDto>(null as any);
    }

    deleteBulkSubCustomers(customerId: number, subCustomerId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/subCustomers?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subCustomerId === null)
            throw new Error("The parameter 'subCustomerId' cannot be null.");
        else if (subCustomerId !== undefined)
            subCustomerId && subCustomerId.forEach(item => { url_ += "subCustomerId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkSubCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkSubCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerDto>;
        }));
    }

    protected processDeleteBulkSubCustomers(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfCustomerDto>(null as any);
    }

    createSubCustomer(customerId: number, subCustomerId: number): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/subCustomers/{subCustomerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subCustomerId === undefined || subCustomerId === null)
            throw new Error("The parameter 'subCustomerId' must be defined.");
        url_ = url_.replace("{subCustomerId}", encodeURIComponent("" + subCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSubCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSubCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processCreateSubCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }

    deleteSubCustomer(customerId: number, subCustomerId: number): Observable<ApiResponseOfCustomerDto> {
        let url_ = this.baseUrl + "/api/customers/{customerId}/subCustomers/{subCustomerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (subCustomerId === undefined || subCustomerId === null)
            throw new Error("The parameter 'subCustomerId' must be defined.");
        url_ = url_.replace("{subCustomerId}", encodeURIComponent("" + subCustomerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSubCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSubCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerDto>;
        }));
    }

    protected processDeleteSubCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerDto>(null as any);
    }
}

export interface IDeliveryConditionApiService {
    getPagedDeliveryConditions(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryConditionDto>;
    createDeliveryCondition(dto: DeliveryConditionDto): Observable<ApiResponseOfDeliveryConditionDto>;
    deleteBulkDeliveryConditions(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryConditionDto>;
    getDeliveryCondition(id: number): Observable<ApiResponseOfDeliveryConditionDto>;
    updateDeliveryCondition(id: number, dto: DeliveryConditionDto): Observable<ApiResponseOfDeliveryConditionDto>;
    deleteDeliveryCondition(id: number): Observable<ApiResponseOfDeliveryConditionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DeliveryConditionApiService implements IDeliveryConditionApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedDeliveryConditions(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedDeliveryConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedDeliveryConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfDeliveryConditionDto>;
        }));
    }

    protected processGetPagedDeliveryConditions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfDeliveryConditionDto>(null as any);
    }

    createDeliveryCondition(dto: DeliveryConditionDto): Observable<ApiResponseOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDeliveryCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDeliveryCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryConditionDto>;
        }));
    }

    protected processCreateDeliveryCondition(response: HttpResponseBase): Observable<ApiResponseOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryConditionDto>(null as any);
    }

    deleteBulkDeliveryConditions(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkDeliveryConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkDeliveryConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfDeliveryConditionDto>;
        }));
    }

    protected processDeleteBulkDeliveryConditions(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfDeliveryConditionDto>(null as any);
    }

    getDeliveryCondition(id: number): Observable<ApiResponseOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliveryCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliveryCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryConditionDto>;
        }));
    }

    protected processGetDeliveryCondition(response: HttpResponseBase): Observable<ApiResponseOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryConditionDto>(null as any);
    }

    updateDeliveryCondition(id: number, dto: DeliveryConditionDto): Observable<ApiResponseOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDeliveryCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDeliveryCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryConditionDto>;
        }));
    }

    protected processUpdateDeliveryCondition(response: HttpResponseBase): Observable<ApiResponseOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryConditionDto>(null as any);
    }

    deleteDeliveryCondition(id: number): Observable<ApiResponseOfDeliveryConditionDto> {
        let url_ = this.baseUrl + "/api/deliveryConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteDeliveryCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteDeliveryCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfDeliveryConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfDeliveryConditionDto>;
        }));
    }

    protected processDeleteDeliveryCondition(response: HttpResponseBase): Observable<ApiResponseOfDeliveryConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfDeliveryConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfDeliveryConditionDto>(null as any);
    }
}

export interface IPaymentConditionsApiService {
    getPagedPaymentConditions(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfPaymentConditionDto>;
    createPaymentCondition(dto: PaymentConditionDto): Observable<ApiResponseOfPaymentConditionDto>;
    deleteBulkPaymentConditions(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfPaymentConditionDto>;
    getPaymentCondition(id: number): Observable<ApiResponseOfPaymentConditionDto>;
    updatePaymentCondition(id: number, dto: PaymentConditionDto): Observable<ApiResponseOfPaymentConditionDto>;
    deletePaymentCondition(id: number): Observable<ApiResponseOfPaymentConditionDto>;
}

@Injectable({
    providedIn: 'root'
})
export class PaymentConditionsApiService implements IPaymentConditionsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedPaymentConditions(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedPaymentConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedPaymentConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfPaymentConditionDto>;
        }));
    }

    protected processGetPagedPaymentConditions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfPaymentConditionDto>(null as any);
    }

    createPaymentCondition(dto: PaymentConditionDto): Observable<ApiResponseOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentConditionDto>;
        }));
    }

    protected processCreatePaymentCondition(response: HttpResponseBase): Observable<ApiResponseOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfPaymentConditionDto>(null as any);
    }

    deleteBulkPaymentConditions(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkPaymentConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkPaymentConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfPaymentConditionDto>;
        }));
    }

    protected processDeleteBulkPaymentConditions(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfPaymentConditionDto>(null as any);
    }

    getPaymentCondition(id: number): Observable<ApiResponseOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentConditionDto>;
        }));
    }

    protected processGetPaymentCondition(response: HttpResponseBase): Observable<ApiResponseOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfPaymentConditionDto>(null as any);
    }

    updatePaymentCondition(id: number, dto: PaymentConditionDto): Observable<ApiResponseOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePaymentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePaymentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentConditionDto>;
        }));
    }

    protected processUpdatePaymentCondition(response: HttpResponseBase): Observable<ApiResponseOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfPaymentConditionDto>(null as any);
    }

    deletePaymentCondition(id: number): Observable<ApiResponseOfPaymentConditionDto> {
        let url_ = this.baseUrl + "/api/paymentConditions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePaymentCondition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePaymentCondition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfPaymentConditionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfPaymentConditionDto>;
        }));
    }

    protected processDeletePaymentCondition(response: HttpResponseBase): Observable<ApiResponseOfPaymentConditionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfPaymentConditionDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfPaymentConditionDto>(null as any);
    }
}

export interface IContactPersonConstructionProjectsApiService {
    getPagedConstructionProjects(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
    deleteBulkConstructionProjects(contactPersonId: number, constructionProjectId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
    createConstructionProjects(contactPersonId: number, constructionProjectId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto>;
    deleteConstructionProject(contactPersonId: number, constructionProjectId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactPersonConstructionProjectsApiService implements IContactPersonConstructionProjectsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedConstructionProjects(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/constructionProjects?";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedConstructionProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedConstructionProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
        }));
    }

    protected processGetPagedConstructionProjects(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfConstructionProjectDto>(null as any);
    }

    deleteBulkConstructionProjects(contactPersonId: number, constructionProjectId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/constructionProjects?";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' cannot be null.");
        else if (constructionProjectId !== undefined)
            constructionProjectId && constructionProjectId.forEach(item => { url_ += "constructionProjectId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkConstructionProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkConstructionProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processDeleteBulkConstructionProjects(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }

    createConstructionProjects(contactPersonId: number, constructionProjectId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/constructionProjects/{constructionProjectId}";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConstructionProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConstructionProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processCreateConstructionProjects(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }

    deleteConstructionProject(contactPersonId: number, constructionProjectId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/constructionProjects/{constructionProjectId}";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteConstructionProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteConstructionProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processDeleteConstructionProject(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }
}

export interface IContactPersonCustomersApiService {
    getPagedCustomers(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto>;
    deleteBulkCustomers(contactPersonId: number, customerId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
    getPagedIndirectCustomers(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto>;
    createCustomer(contactPersonId: number, customerId: number): Observable<ApiResponseOfCustomerContactPersonDto>;
    deleteCustomer(contactPersonId: number, customerId: number): Observable<ApiResponseOfCustomerContactPersonDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactPersonCustomersApiService implements IContactPersonCustomersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedCustomers(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/customers?";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
        }));
    }

    protected processGetPagedCustomers(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCustomerDto>(null as any);
    }

    deleteBulkCustomers(contactPersonId: number, customerId?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/customers?";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (customerId === null)
            throw new Error("The parameter 'customerId' cannot be null.");
        else if (customerId !== undefined)
            customerId && customerId.forEach(item => { url_ += "customerId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processDeleteBulkCustomers(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfCustomerContactPersonDto>(null as any);
    }

    getPagedIndirectCustomers(contactPersonId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/customers/indirect?";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedIndirectCustomers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedIndirectCustomers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfCustomerDto>;
        }));
    }

    protected processGetPagedIndirectCustomers(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfCustomerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfCustomerDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfCustomerDto>(null as any);
    }

    createCustomer(contactPersonId: number, customerId: number): Observable<ApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/customers/{customerId}";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processCreateCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerContactPersonDto>(null as any);
    }

    deleteCustomer(contactPersonId: number, customerId: number): Observable<ApiResponseOfCustomerContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{contactPersonId}/customers/{customerId}";
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfCustomerContactPersonDto>;
        }));
    }

    protected processDeleteCustomer(response: HttpResponseBase): Observable<ApiResponseOfCustomerContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfCustomerContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfCustomerContactPersonDto>(null as any);
    }
}

export interface IContactPersonsApiService {
    getPagedContactPersons(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
    createContactPerson(dto: ContactPersonDto): Observable<ApiResponseOfContactPersonDto>;
    deleteBulkContactPersons(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfContactPersonDto>;
    getContactPerson(id: number): Observable<ApiResponseOfContactPersonDto>;
    updateContactPerson(id: number, dto: ContactPersonDto): Observable<ApiResponseOfContactPersonDto>;
    deleteContactPerson(id: number): Observable<ApiResponseOfContactPersonDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ContactPersonsApiService implements IContactPersonsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedContactPersons(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfContactPersonDto>;
        }));
    }

    protected processGetPagedContactPersons(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfContactPersonDto>(null as any);
    }

    createContactPerson(dto: ContactPersonDto): Observable<ApiResponseOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfContactPersonDto>;
        }));
    }

    protected processCreateContactPerson(response: HttpResponseBase): Observable<ApiResponseOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactPersonDto>(null as any);
    }

    deleteBulkContactPersons(id?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            id && id.forEach(item => { url_ += "id=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfContactPersonDto>;
        }));
    }

    protected processDeleteBulkContactPersons(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfContactPersonDto>(null as any);
    }

    getContactPerson(id: number): Observable<ApiResponseOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfContactPersonDto>;
        }));
    }

    protected processGetContactPerson(response: HttpResponseBase): Observable<ApiResponseOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactPersonDto>(null as any);
    }

    updateContactPerson(id: number, dto: ContactPersonDto): Observable<ApiResponseOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfContactPersonDto>;
        }));
    }

    protected processUpdateContactPerson(response: HttpResponseBase): Observable<ApiResponseOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactPersonDto>(null as any);
    }

    deleteContactPerson(id: number): Observable<ApiResponseOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/contactPersons/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfContactPersonDto>;
        }));
    }

    protected processDeleteContactPerson(response: HttpResponseBase): Observable<ApiResponseOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfContactPersonDto>(null as any);
    }
}

export interface IConstructionProjectContactPersonsApiService {
    getAllContactPersons(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfContactPersonDto>;
    deleteBulkContactPersons(constructionProjectId: number, contactPersonIds?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
    createContactPersons(constructionProjectId: number, contactPersonId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto>;
    deleteContactPerson(constructionProjectId: number, contactPersonId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto>;
    setContactPersons(constructionProjectId: number, newContactPersons: ConstructionProjectContactPersonsDto): Observable<ApiResponseOfConstructionProjectContactPersonsDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionProjectContactPersonsApiService implements IConstructionProjectContactPersonsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllContactPersons(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfContactPersonDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/contactPersons?";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfContactPersonDto>;
        }));
    }

    protected processGetAllContactPersons(response: HttpResponseBase): Observable<ApiResponseOfListOfContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfContactPersonDto>(null as any);
    }

    deleteBulkContactPersons(constructionProjectId: number, contactPersonIds?: number[] | undefined): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/contactPersons?";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (contactPersonIds === null)
            throw new Error("The parameter 'contactPersonIds' cannot be null.");
        else if (contactPersonIds !== undefined)
            contactPersonIds && contactPersonIds.forEach(item => { url_ += "contactPersonIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBulkContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBulkContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processDeleteBulkContactPersons(response: HttpResponseBase): Observable<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }

    createContactPersons(constructionProjectId: number, contactPersonId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/contactPersons/{contactPersonId}";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processCreateContactPersons(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }

    deleteContactPerson(constructionProjectId: number, contactPersonId: number): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/contactPersons/{contactPersonId}";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (contactPersonId === undefined || contactPersonId === null)
            throw new Error("The parameter 'contactPersonId' must be defined.");
        url_ = url_.replace("{contactPersonId}", encodeURIComponent("" + contactPersonId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContactPerson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContactPerson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectContactPersonDto>;
        }));
    }

    protected processDeleteContactPerson(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectContactPersonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectContactPersonDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectContactPersonDto>(null as any);
    }

    setContactPersons(constructionProjectId: number, newContactPersons: ConstructionProjectContactPersonsDto): Observable<ApiResponseOfConstructionProjectContactPersonsDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/contactPersons/set";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newContactPersons);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetContactPersons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetContactPersons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectContactPersonsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectContactPersonsDto>;
        }));
    }

    protected processSetContactPersons(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectContactPersonsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectContactPersonsDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectContactPersonsDto>(null as any);
    }
}

export interface IConstructionProjectsApiService {
    getPagedConstructionProjects(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
    createConstructionProject(dto: ConstructionProjectDto): Observable<ApiResponseOfConstructionProjectDto>;
    getConstructionProject(id: number): Observable<ApiResponseOfConstructionProjectDto>;
    updateConstructionProject(id: number, dto: ConstructionProjectDto): Observable<ApiResponseOfConstructionProjectDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionProjectsApiService implements IConstructionProjectsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedConstructionProjects(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/constructionProjects?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedConstructionProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedConstructionProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfConstructionProjectDto>;
        }));
    }

    protected processGetPagedConstructionProjects(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfConstructionProjectDto>(null as any);
    }

    createConstructionProject(dto: ConstructionProjectDto): Observable<ApiResponseOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/constructionProjects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateConstructionProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateConstructionProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectDto>;
        }));
    }

    protected processCreateConstructionProject(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectDto>(null as any);
    }

    getConstructionProject(id: number): Observable<ApiResponseOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConstructionProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConstructionProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectDto>;
        }));
    }

    protected processGetConstructionProject(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectDto>(null as any);
    }

    updateConstructionProject(id: number, dto: ConstructionProjectDto): Observable<ApiResponseOfConstructionProjectDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateConstructionProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateConstructionProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfConstructionProjectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfConstructionProjectDto>;
        }));
    }

    protected processUpdateConstructionProject(response: HttpResponseBase): Observable<ApiResponseOfConstructionProjectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfConstructionProjectDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfConstructionProjectDto>(null as any);
    }
}

export interface IDistanceCalculationApiService {
    calculateDistance(zipCode?: string | null | undefined, city?: string | null | undefined, street?: string | null | undefined, houseNr?: string | null | undefined, country?: string | null | undefined, warehouseId?: number | undefined): Observable<number | null>;
}

@Injectable({
    providedIn: 'root'
})
export class DistanceCalculationApiService implements IDistanceCalculationApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    calculateDistance(zipCode?: string | null | undefined, city?: string | null | undefined, street?: string | null | undefined, houseNr?: string | null | undefined, country?: string | null | undefined, warehouseId?: number | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/distanceCalculation?";
        if (zipCode !== undefined && zipCode !== null)
            url_ += "ZipCode=" + encodeURIComponent("" + zipCode) + "&";
        if (city !== undefined && city !== null)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (street !== undefined && street !== null)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (houseNr !== undefined && houseNr !== null)
            url_ += "HouseNr=" + encodeURIComponent("" + houseNr) + "&";
        if (country !== undefined && country !== null)
            url_ += "Country=" + encodeURIComponent("" + country) + "&";
        if (warehouseId === null)
            throw new Error("The parameter 'warehouseId' cannot be null.");
        else if (warehouseId !== undefined)
            url_ += "WarehouseId=" + encodeURIComponent("" + warehouseId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateDistance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateDistance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processCalculateDistance(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number | null>(null as any);
    }
}

export interface IAmountUnitsApiService {
    getPagedAmountUnits(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfAmountUnitDto>;
    getAmountUnit(id: number): Observable<ApiResponseOfAmountUnitDto>;
}

@Injectable({
    providedIn: 'root'
})
export class AmountUnitsApiService implements IAmountUnitsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedAmountUnits(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfAmountUnitDto> {
        let url_ = this.baseUrl + "/api/amountUnits?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedAmountUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedAmountUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfAmountUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfAmountUnitDto>;
        }));
    }

    protected processGetPagedAmountUnits(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfAmountUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfAmountUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfAmountUnitDto>(null as any);
    }

    getAmountUnit(id: number): Observable<ApiResponseOfAmountUnitDto> {
        let url_ = this.baseUrl + "/api/amountUnits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAmountUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAmountUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfAmountUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfAmountUnitDto>;
        }));
    }

    protected processGetAmountUnit(response: HttpResponseBase): Observable<ApiResponseOfAmountUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfAmountUnitDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfAmountUnitDto>(null as any);
    }
}

export interface ITimeUnitsApiService {
    getPagedTimeUnits(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfTimeUnitDto>;
    getTimeUnit(id: number): Observable<ApiResponseOfTimeUnitDto>;
}

@Injectable({
    providedIn: 'root'
})
export class TimeUnitsApiService implements ITimeUnitsApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getPagedTimeUnits(skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfIEnumerableOfTimeUnitDto> {
        let url_ = this.baseUrl + "/api/timeUnits?";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedTimeUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedTimeUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfTimeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfTimeUnitDto>;
        }));
    }

    protected processGetPagedTimeUnits(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfTimeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfTimeUnitDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfTimeUnitDto>(null as any);
    }

    getTimeUnit(id: number): Observable<ApiResponseOfTimeUnitDto> {
        let url_ = this.baseUrl + "/api/timeUnits/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfTimeUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfTimeUnitDto>;
        }));
    }

    protected processGetTimeUnit(response: HttpResponseBase): Observable<ApiResponseOfTimeUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfTimeUnitDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTimeUnitDto>(null as any);
    }
}

export interface IConstructionProjectInvoicesApiService {
    getAllInvoices(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfInvoiceDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionProjectInvoicesApiService implements IConstructionProjectInvoicesApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllInvoices(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfInvoiceDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/invoices?";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfInvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfInvoiceDto>;
        }));
    }

    protected processGetAllInvoices(response: HttpResponseBase): Observable<ApiResponseOfListOfInvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfInvoiceDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfInvoiceDto>(null as any);
    }
}

export interface IConstructionProjectOffersApiService {
    getAllOffers(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfOfferDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionProjectOffersApiService implements IConstructionProjectOffersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllOffers(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfOfferDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/offers?";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOffers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOffers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfOfferDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfOfferDto>;
        }));
    }

    protected processGetAllOffers(response: HttpResponseBase): Observable<ApiResponseOfListOfOfferDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfOfferDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfOfferDto>(null as any);
    }
}

export interface IConstructionProjectOrdersApiService {
    getAllOrders(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfOrderDto>;
}

@Injectable({
    providedIn: 'root'
})
export class ConstructionProjectOrdersApiService implements IConstructionProjectOrdersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getAllOrders(constructionProjectId: number, skip?: number | undefined, take?: number | undefined, filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined): Observable<ApiResponseOfListOfOrderDto> {
        let url_ = this.baseUrl + "/api/constructionProjects/{constructionProjectId}/orders?";
        if (constructionProjectId === undefined || constructionProjectId === null)
            throw new Error("The parameter 'constructionProjectId' must be defined.");
        url_ = url_.replace("{constructionProjectId}", encodeURIComponent("" + constructionProjectId));
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfListOfOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfListOfOrderDto>;
        }));
    }

    protected processGetAllOrders(response: HttpResponseBase): Observable<ApiResponseOfListOfOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfListOfOrderDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfListOfOrderDto>(null as any);
    }
}

export interface IInfoApiService {
    /**
     * Get api info
     */
    get(): Observable<ApiResponseOfApiInfo>;
}

@Injectable({
    providedIn: 'root'
})
export class InfoApiService implements IInfoApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    /**
     * Get api info
     */
    get(): Observable<ApiResponseOfApiInfo> {
        let url_ = this.baseUrl + "/api/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfApiInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfApiInfo>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ApiResponseOfApiInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiInfo;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfApiInfo>(null as any);
    }
}

export interface IAuthApiService {
    /**
     * Logs in a user
     */
    login(dto: LoginDto): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
    /**
     * Logs out a user
     */
    logout(dto: LogoutDto): Observable<ApiResponse>;
    /**
     * Renews a token
     */
    renewToken(dto: TokenRenewalDto): Observable<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto>;
    /**
     * Gets permissions
     */
    getPermissions(): Observable<ApiResponseOfIEnumerableOfPermissionDto>;
    /**
     * Impersonates a user
     */
    impersonate(dto: ImpersonateDto): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
    /**
     * Changes the user password
     */
    changePassword(dto: ChangePasswordDto): Observable<ApiResponse>;
    /**
     * Send password forgotten mail
     */
    forgotPassword(dto: ForgotPasswordDto): Observable<ApiResponse>;
    /**
     * Resets the user password
     */
    resetPassword(dto: ResetPasswordDto): Observable<ApiResponse>;
    /**
     * Activates a user
     */
    activateAccount(dto: ActivateUserDto): Observable<ApiResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AuthApiService implements IAuthApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    /**
     * Logs in a user
     */
    login(dto: LoginDto): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/auth/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfLoginResultDtoOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfLoginResultDtoOfRuiterUserDto>(null as any);
    }

    /**
     * Logs out a user
     */
    logout(dto: LogoutDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/auth/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogout(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogout(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponse>;
        }));
    }

    protected processLogout(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(null as any);
    }

    /**
     * Renews a token
     */
    renewToken(dto: TokenRenewalDto): Observable<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/auth/renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto>;
        }));
    }

    protected processRenewToken(response: HttpResponseBase): Observable<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfModelStateDictionary;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto>(null as any);
    }

    /**
     * Gets permissions
     */
    getPermissions(): Observable<ApiResponseOfIEnumerableOfPermissionDto> {
        let url_ = this.baseUrl + "/api/auth/permissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfPermissionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfPermissionDto>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfPermissionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfPermissionDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfPermissionDto>(null as any);
    }

    /**
     * Impersonates a user
     */
    impersonate(dto: ImpersonateDto): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/auth/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ApiResponseOfLoginResultDtoOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfLoginResultDtoOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfLoginResultDtoOfRuiterUserDto>(null as any);
    }

    /**
     * Changes the user password
     */
    changePassword(dto: ChangePasswordDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/auth/changePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponse>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(null as any);
    }

    /**
     * Send password forgotten mail
     */
    forgotPassword(dto: ForgotPasswordDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/auth/forgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponse>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(null as any);
    }

    /**
     * Resets the user password
     */
    resetPassword(dto: ResetPasswordDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/auth/resetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(null as any);
    }

    /**
     * Activates a user
     */
    activateAccount(dto: ActivateUserDto): Observable<ApiResponse> {
        let url_ = this.baseUrl + "/api/auth/activate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponse>;
        }));
    }

    protected processActivateAccount(response: HttpResponseBase): Observable<ApiResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponse>(null as any);
    }
}

export interface IUsersApiService {
    /**
     * Invite user
     */
    inviteUser(dto: InviteUserDto): Observable<ApiResponseOfRuiterUserDto>;
    getPagedUsers(filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfRuiterUserDto>;
    /**
     * Reinvite user
     */
    reinviteUser(dto: ReinviteUserDto): Observable<ApiResponseOfRuiterUserDto>;
    getUser(id: number): Observable<ApiResponseOfRuiterUserDto>;
    updateUser(id: number, dto: RuiterUserDto): Observable<ApiResponseOfRuiterUserDto>;
    deleteUser(id: number): Observable<ApiResponseOfRuiterUserDto>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersApiService implements IUsersApiService {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    /**
     * Invite user
     */
    inviteUser(dto: InviteUserDto): Observable<ApiResponseOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInviteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInviteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRuiterUserDto>;
        }));
    }

    protected processInviteUser(response: HttpResponseBase): Observable<ApiResponseOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRuiterUserDto>(null as any);
    }

    getPagedUsers(filterName?: string[] | null | undefined, filterValue?: string | null | undefined, sortName?: string[] | null | undefined, sortDirection?: ApiSortDirection | undefined, skip?: number | undefined, take?: number | undefined): Observable<ApiResponseOfIEnumerableOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users?";
        if (filterName !== undefined && filterName !== null)
            filterName && filterName.forEach(item => { url_ += "filterName=" + encodeURIComponent("" + item) + "&"; });
        if (filterValue !== undefined && filterValue !== null)
            url_ += "filterValue=" + encodeURIComponent("" + filterValue) + "&";
        if (sortName !== undefined && sortName !== null)
            sortName && sortName.forEach(item => { url_ += "sortName=" + encodeURIComponent("" + item) + "&"; });
        if (sortDirection === null)
            throw new Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPagedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPagedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfIEnumerableOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfIEnumerableOfRuiterUserDto>;
        }));
    }

    protected processGetPagedUsers(response: HttpResponseBase): Observable<ApiResponseOfIEnumerableOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfIEnumerableOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfIEnumerableOfRuiterUserDto>(null as any);
    }

    /**
     * Reinvite user
     */
    reinviteUser(dto: ReinviteUserDto): Observable<ApiResponseOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users/reinvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReinviteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReinviteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRuiterUserDto>;
        }));
    }

    protected processReinviteUser(response: HttpResponseBase): Observable<ApiResponseOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRuiterUserDto>(null as any);
    }

    getUser(id: number): Observable<ApiResponseOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRuiterUserDto>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<ApiResponseOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRuiterUserDto>(null as any);
    }

    updateUser(id: number, dto: RuiterUserDto): Observable<ApiResponseOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRuiterUserDto>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<ApiResponseOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfApiValidationResult;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRuiterUserDto>(null as any);
    }

    deleteUser(id: number): Observable<ApiResponseOfRuiterUserDto> {
        let url_ = this.baseUrl + "/api/users/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApiResponseOfRuiterUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApiResponseOfRuiterUserDto>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<ApiResponseOfRuiterUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponseOfRuiterUserDto;
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ApiResponseOfRuiterUserDto>(null as any);
    }
}

export interface ApiResponse {
    success: boolean;
    message: string | null;
    count: number | null;
    maxCount: number | null;
}

export interface ApiResponseOfIEnumerableOfArticleDto extends ApiResponse {
    data: ArticleDto[];
}

export interface BaseDto {
    id: number | null;
    created: string | null;
    lastChange: string | null;
}

export interface ArticleDto extends BaseDto {
    position: number | null;
    name: string;
    abbreviation: string;
    description: string | null;
    length: number;
    width: number;
    strength: number;
    ean: string | null;
    price: ArticlePriceDto;
    antiTheftPrice: ArticleAntiTheftPriceDto;
    revenueAccount: ArticleRevenueAccountDto;
    deliveryVehicleType: VehicleTypeDto | null;
    deliveryVehicleTypeId: number;
    loadingVehicleType: VehicleTypeDto | null;
    loadingVehicleTypeId: number;
    material: Material;
    graduatedPrices: ArticleGraduatedPriceDto[] | null;
}

export interface ArticlePriceDto extends BaseDto {
    rentPrice: number;
    rentRenewalPrice: number;
    theftProtectionPrice: number;
    basePrice: number;
    movePrice: number;
    rollingPrice: number;
    cleaningPrice: number;
}

export interface ArticleAntiTheftPriceDto {
    deductibleRatePercent: number;
    minimumDeductible: number;
}

export interface ArticleRevenueAccountDto {
    rentAccount: string;
    deliveryAccount: string;
    departureAccount: string;
    moveAccount: string;
    rollingAccount: string;
    cleaningAccount: string;
    theftProtectionAccount: string;
    otherAccount: string;
}

export interface VehicleTypeDto extends BaseDto {
    name: string;
    material: Material;
    speed: number;
    loadCapacity: number;
    turnoverSpeed: number;
    price: VehicleTypePriceDto;
}

export enum Material {
    Steel = "steel",
    Plastic = "plastic",
}

export interface VehicleTypePriceDto extends BaseDto {
    basePrice: number;
    pricePerHour: number;
}

export interface ArticleGraduatedPriceDto extends ArticlePriceDto {
    fromCount: number;
    toCount: number;
}

export enum ApiSortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface ApiResponseOfArticleDto extends ApiResponse {
    data: ArticleDto;
}

export interface ApiResponseOfApiValidationResult extends ApiResponse {
    data: ApiValidationResult;
}

export interface ApiValidationResult {
    errors: { [key: string]: string[]; };
}

export interface ApiResponseOfListOfApiResponseOfArticleDto extends ApiResponse {
    data: ApiResponseOfArticleDto[];
}

export interface ApiResponseOfString extends ApiResponse {
    data: string;
}

export enum ReceiptType {
    Offer = "offer",
    Order = "order",
    Invoice = "invoice",
    CreditNote = "creditNote",
    DeliveryNote = "deliveryNote",
}

export interface ApiResponseOfIEnumerableOfWarehouseDto extends ApiResponse {
    data: WarehouseDto[];
}

export interface WarehouseDto extends BaseDto {
    name: string;
    address: string;
}

export interface ApiResponseOfWarehouseDto extends ApiResponse {
    data: WarehouseDto;
}

export interface ApiResponseOfListOfApiResponseOfWarehouseDto extends ApiResponse {
    data: ApiResponseOfWarehouseDto[];
}

export interface ApiResponseOfIEnumerableOfVehicleDto extends ApiResponse {
    data: VehicleDto[];
}

export interface VehicleDto extends BaseDto {
    name: string;
    licensePlate: string | null;
    driverName: string | null;
    driverMail: string | null;
    driverPhone: string | null;
    comment: string | null;
    isExternal: boolean;
    externalMailAddress: string | null;
}

export interface ApiResponseOfVehicleDto extends ApiResponse {
    data: VehicleDto;
}

export interface ApiResponseOfListOfApiResponseOfVehicleDto extends ApiResponse {
    data: ApiResponseOfVehicleDto[];
}

export interface ApiResponseOfIEnumerableOfVehicleTypeDto extends ApiResponse {
    data: VehicleTypeDto[];
}

export interface ApiResponseOfVehicleTypeDto extends ApiResponse {
    data: VehicleTypeDto;
}

export interface ApiResponseOfListOfApiResponseOfVehicleTypeDto extends ApiResponse {
    data: ApiResponseOfVehicleTypeDto[];
}

export interface ApiResponseOfListOfPlateCountStatisticDto extends ApiResponse {
    data: PlateCountStatisticDto[];
}

export interface PlateCountStatisticDto {
    zipCodePrefix: string;
    plateCount: number;
}

export interface ApiResponseOfApplicationSettingsDto extends ApiResponse {
    data: ApplicationSettingsDto;
}

export interface ApplicationSettingsDto {
    steelCalculationFactor: number;
    receiptExternalCalculationFactorPercent: number;
    receiptExternalCalculationMinimumDistance: number;
    defaultPaymentTermDays: number;
    defaultCountry: CountryDto | null;
    defaultCountryId: number | null;
    externalCalculationPlateCount: number;
    dueDateExtensionOnPostal: number;
    defaultWarehouse: WarehouseDto;
    defaultWarehouseId: number;
    replyNotificationEmail: string;
    defaultOfferFooterText: string;
    defaultOfferHeaderText: string;
    defaultDispositionMailBcc: string[];
}

export interface CountryDto extends BaseDto {
    name: string;
    alpha2Code: string;
    alpha3Code: string;
}

export interface ApiResponseOfListOfReceiptExportFieldSettingsDto extends ApiResponse {
    data: ReceiptExportFieldSettingsDto[];
}

export interface ReceiptExportFieldSettingsDto extends BaseDto {
    receiptType: ReceiptExportType;
    fieldName: string;
    fieldIndex: number | null;
}

export enum ReceiptExportType {
    Offer = "offer",
    Order = "order",
    Invoice = "invoice",
    CreditNote = "creditNote",
    DeliveryNote = "deliveryNote",
}

export interface ApiResponseOfListOfString extends ApiResponse {
    data: string[];
}

export interface ApiResponseOfTransferOrderDto extends ApiResponse {
    data: TransferOrderDto;
}

export interface TransferOrderDto {
    kind: string;
    invoiceDate: string;
    pickupData: TransferOrderPickupDto | null;
    rentalData: TransferOrderRentalDto | null;
    deliveryNoteIds: number[];
}

export interface TransferOrderPickupDto {
    articles: ArticlePickupDto[];
}

export interface ArticlePickupDto {
    article: ArticleDto | null;
    articleId: number;
    plateCount: number;
    pickupDate: string;
}

export interface TransferOrderRentalDto {
    positions: TransferOrderRentalPositionDto[];
}

export interface TransferOrderRentalPositionDto {
    articleId: number;
    article: ArticleDto | null;
    amount: number;
    amountUnit: PlateUnit;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
}

export enum PlateUnit {
    PerMeter = "lfm",
    SquareMeter = "qm",
    Piece = "piece",
}

export interface ApiResponseOfDownloadReportDto extends ApiResponse {
    data: DownloadReportDto;
}

export interface DownloadReportDto {
    token: string;
    url: string;
}

export enum ReportMode {
    Digital = "Digital",
    Analog = "Analog",
    DeliveryNote = "DeliveryNote",
}

export interface ApiResponseOfIEnumerableOfOrderDto extends ApiResponse {
    data: OrderDto[];
}

export interface BaseReceiptDtoOfOrderVersionDtoAndOrderPositionDtoAndOrderStatusDto extends BaseDto {
    latestVersion: OrderVersionDto;
    isReadOnly: boolean;
    number: string | null;
    constructionProject: ConstructionProjectDto | null;
    constructionProjectId: number;
    createdBy: RuiterUserDto | null;
    createdById: number | null;
}

export interface OrderDto extends BaseReceiptDtoOfOrderVersionDtoAndOrderPositionDtoAndOrderStatusDto {
    costCenter: string;
    transferredFromOffer: OfferDto | null;
    transferredFromOfferId: number;
}

export interface BaseReceiptDtoOfOfferVersionDtoAndOfferPositionDtoAndOfferStatusDto extends BaseDto {
    latestVersion: OfferVersionDto;
    isReadOnly: boolean;
    number: string | null;
    constructionProject: ConstructionProjectDto | null;
    constructionProjectId: number;
    createdBy: RuiterUserDto | null;
    createdById: number | null;
}

export interface OfferDto extends BaseReceiptDtoOfOfferVersionDtoAndOfferPositionDtoAndOfferStatusDto {
}

export interface BaseReceiptVersionDtoOfOfferPositionDtoAndOfferStatusDto extends BaseDto {
    versionNumber: number | null;
    deliveryDate: string | null;
    vat: number;
    headerText: string | null;
    footerText: string | null;
    kind: string;
    comment: string | null;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
    rentDurationAmount: number | null;
    rentDurationUnit: TimeUnit;
    numberOfTransports: number;
    price: ReceiptPriceDto | null;
    positions: OfferPositionDto[] | null;
    receiptId: number;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    createdBy: RuiterUserDto | null;
    createdById: number;
    billRecipient: CustomerDto | null;
    billRecipientId: number;
    statusId: number;
    status: OfferStatusDto;
}

export interface OfferVersionDto extends BaseReceiptVersionDtoOfOfferPositionDtoAndOfferStatusDto {
    materialAvailabilityText: string;
}

export enum TimeUnit {
    Days = "days",
    Months = "months",
}

export interface ReceiptPriceDto {
    totalNetPrice: number;
    totalGrossPrice: number;
    vatAmount: number;
}

export interface BaseReceiptPositionDto extends BaseDto {
    index: number;
    price: number | null;
    totalPrice: number;
    name: string;
    printText: string;
    type: PositionType;
    amount: number | null;
    amountUnit: string | null;
    timeAmount: number | null;
    timeUnit: string | null;
    revenueAccount: string;
    article: ArticleDto | null;
    articleId: number | null;
}

export interface OfferPositionDto extends BaseReceiptPositionDto {
}

export enum PositionType {
    Undefined = "undefined",
    Delivery = "delivery",
    Rent = "rent",
    Departure = "departure",
    AntiTheft = "theftProtection",
}

export interface PaymentConditionDto extends BaseDto {
    name: string;
    printText: string | null;
    discounts: DiscountDto[] | null;
}

export interface DiscountDto extends BaseDto {
    fromCount: number;
    toCount: number;
    discountValue: number;
}

export interface DeliveryConditionDto extends BaseDto {
    name: string;
    printText: string | null;
}

export interface UserDto extends BaseDto {
    username: string | null;
    firstname: string | null;
    lastname: string | null;
    isEnabled: boolean;
    isPasswordChangeRequired: boolean;
    permissions: string[] | null;
    status: UserStatus;
}

export interface RuiterUserDto extends UserDto {
    phoneNumber: string | null;
}

export enum UserStatus {
    Invited = "Invited",
    Joined = "Joined",
}

export interface CustomerDto extends BaseDto {
    firstname: string | null;
    lastname: string | null;
    company: string | null;
    salutation: Salutation;
    comment: string | null;
    note: string | null;
    vatIdentificationNumber: string | null;
    billingPostal: boolean;
    billingMail: boolean;
    revenueAccount: string | null;
    isInactive: boolean;
    noAntiTheftProtection: boolean;
    billingAddress: AddressDto | null;
    contactOptions: ContactOptionsDto | null;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    parentCustomer: CustomerDto | null;
    parentCustomerId: number | null;
    articlePrices: CustomerArticlePriceDto[] | null;
    vehicleTypePrices: CustomerVehicleTypePriceDto[] | null;
    mailboxes: MailboxDto[] | null;
}

export enum Salutation {
    None = "none",
    Mr = "mr",
    Mrs = "mrs",
    Company = "company",
}

export interface AddressDto extends BaseDto {
    additionalAddressLine: string | null;
    street: string | null;
    houseNumber: string | null;
    zipCode: string | null;
    city: string | null;
    country: CountryDto | null;
    countryId: number | null;
}

export interface ContactOptionsDto extends BaseDto {
    phone: string | null;
    mobile: string | null;
    mail: string | null;
    fax: string | null;
}

export interface CustomerArticlePriceDto extends BaseDto {
    article: ArticleDto | null;
    articleId: number;
    rentPrice: number | null;
    rentRenewalPrice: number | null;
    theftProtectionPrice: number | null;
    basePrice: number | null;
    movePrice: number | null;
    rollingPrice: number | null;
    cleaningPrice: number | null;
}

export interface CustomerVehicleTypePriceDto extends BaseDto {
    vehicleType: VehicleTypeEntity | null;
    vehicleTypeId: number;
    basePrice: number | null;
    pricePerHour: number | null;
}

export interface BaseEntity {
    id: number;
    isDeleted: boolean;
    created: string;
    lastChange: string;
}

export interface VehicleTypeEntity extends BaseEntity {
    name: string;
    material: Material;
    speed: number;
    loadCapacity: number;
    turnoverSpeed: number;
    price: VehicleTypePriceEntity;
}

export interface VehicleTypePriceEntity extends BaseEntity {
    basePrice: number;
    pricePerHour: number;
    vehicleType: VehicleTypeEntity;
    vehicleTypeId: number;
}

export interface MailboxDto extends BaseDto {
    name: string;
    mailboxNumber: string;
}

export interface BaseReceiptStatusDto extends BaseDto {
    status: string;
}

export interface OfferStatusDto extends BaseReceiptStatusDto {
}

export interface ConstructionProjectDto extends BaseDto {
    name: string;
    distance: number;
    isClosed: boolean;
    address: AddressDto | null;
    comment: string | null;
    customer: CustomerDto | null;
    customerId: number;
    articlePrices: ConstructionProjectArticlePriceDto[] | null;
    vehicleTypePrices: ConstructionProjectVehicleTypePriceDto[] | null;
    warehouse: WarehouseDto | null;
    warehouseId: number;
}

export interface ConstructionProjectArticlePriceDto extends BaseDto {
    article: ArticleDto | null;
    articleId: number;
    rentPrice: number | null;
    rentRenewalPrice: number | null;
    theftProtectionPrice: number | null;
    basePrice: number | null;
    movePrice: number | null;
    rollingPrice: number | null;
    cleaningPrice: number | null;
}

export interface ConstructionProjectVehicleTypePriceDto extends BaseDto {
    vehicleType: VehicleTypeEntity | null;
    vehicleTypeId: number;
    basePrice: number | null;
    pricePerHour: number | null;
}

export interface BaseReceiptVersionDtoOfOrderPositionDtoAndOrderStatusDto extends BaseDto {
    versionNumber: number | null;
    deliveryDate: string | null;
    vat: number;
    headerText: string | null;
    footerText: string | null;
    kind: string;
    comment: string | null;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
    rentDurationAmount: number | null;
    rentDurationUnit: TimeUnit;
    numberOfTransports: number;
    price: ReceiptPriceDto | null;
    positions: OrderPositionDto[] | null;
    receiptId: number;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    createdBy: RuiterUserDto | null;
    createdById: number;
    billRecipient: CustomerDto | null;
    billRecipientId: number;
    statusId: number;
    status: OrderStatusDto;
}

export interface OrderVersionDto extends BaseReceiptVersionDtoOfOrderPositionDtoAndOrderStatusDto {
}

export interface OrderPositionDto extends BaseReceiptPositionDto {
}

export interface OrderStatusDto extends BaseReceiptStatusDto {
}

export interface ApiResponseOfOrderDto extends ApiResponse {
    data: OrderDto;
}

export interface ApiResponseOfOrderVersionDto extends ApiResponse {
    data: OrderVersionDto;
}

export interface ApiResponseOfOrderPositionDto extends ApiResponse {
    data: OrderPositionDto;
}

export interface DefaultPositionCalculationDto {
    articleId: number | null;
    article: ArticleDto | null;
    positionType: PositionType | null;
}

export interface ApiResponseOfListOfOrderVersionDto extends ApiResponse {
    data: OrderVersionDto[];
}

export interface ReceiptStatusUpdateDtoOfOrderDtoAndOrderStatusDto {
    newStatusId: number;
    receiptIds: number[];
}

export interface ApiResponseOfListOfBaseReceiptStatusDto extends ApiResponse {
    data: BaseReceiptStatusDto[];
}

export interface ApiResponseOfInvoiceDto extends ApiResponse {
    data: InvoiceDto;
}

export interface BaseReceiptDtoOfInvoiceVersionDtoAndInvoicePositionDtoAndInvoiceStatusDto extends BaseDto {
    latestVersion: InvoiceVersionDto;
    isReadOnly: boolean;
    number: string | null;
    constructionProject: ConstructionProjectDto | null;
    constructionProjectId: number;
    createdBy: RuiterUserDto | null;
    createdById: number | null;
}

export interface InvoiceDto extends BaseReceiptDtoOfInvoiceVersionDtoAndInvoicePositionDtoAndInvoiceStatusDto {
    costCenter: string;
    transferredFromOrder: OrderDto | null;
    transferredFromOrderId: number;
    hasDownloads: boolean | null;
    paymentSum: number | null;
    payments: InvoicePaymentDto[];
}

export interface InvoicePaymentDto extends BaseDto {
    invoiceId: number;
    paymentDate: string;
    paymentAmount: number;
    withDiscount: boolean;
    invoice: InvoiceDto;
}

export interface BaseReceiptVersionDtoOfInvoicePositionDtoAndInvoiceStatusDto extends BaseDto {
    versionNumber: number | null;
    deliveryDate: string | null;
    vat: number;
    headerText: string | null;
    footerText: string | null;
    kind: string;
    comment: string | null;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
    rentDurationAmount: number | null;
    rentDurationUnit: TimeUnit;
    numberOfTransports: number;
    price: ReceiptPriceDto | null;
    positions: InvoicePositionDto[] | null;
    receiptId: number;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    createdBy: RuiterUserDto | null;
    createdById: number;
    billRecipient: CustomerDto | null;
    billRecipientId: number;
    statusId: number;
    status: InvoiceStatusDto;
}

export interface InvoiceVersionDto extends BaseReceiptVersionDtoOfInvoicePositionDtoAndInvoiceStatusDto {
    invoiceDate: string;
    dueDate: string;
    pickupDate: string | null;
    isReleased: boolean;
    zugferdBuyerReference: string | null;
    zugferdOrderReference: string | null;
    zugferdProjectReference: string | null;
    calculatedDiscounts: CalculatedDiscountDto[] | null;
    deliveryNoteAssignments: InvoiceDeliveryNoteAssignmentDto[];
}

export interface CalculatedDiscountDto {
    discount: DiscountDto;
    calculatedAmount: number;
}

export interface InvoiceDeliveryNoteAssignmentDto extends BaseDto {
    invoiceVersionId: number;
    deliveryNoteId: number;
    invoiceVersion: InvoiceVersionDto | null;
    deliveryNote: DeliveryNoteDto | null;
}

export interface BaseReceiptDtoOfDeliveryNoteVersionDtoAndDeliveryNotePositionDtoAndDeliveryNoteStatusDto extends BaseDto {
    latestVersion: DeliveryNoteVersionDto;
    isReadOnly: boolean;
    number: string | null;
    constructionProject: ConstructionProjectDto | null;
    constructionProjectId: number;
    createdBy: RuiterUserDto | null;
    createdById: number | null;
}

export interface DeliveryNoteDto extends BaseReceiptDtoOfDeliveryNoteVersionDtoAndDeliveryNotePositionDtoAndDeliveryNoteStatusDto {
    remoteAccessToken: string;
    transferredFromOrder: OrderDto | null;
    transferredFromOrderId: number;
    invoices: InvoiceDto[];
    assignments: DeliveryNoteAssignmentDto[];
}

export interface DeliveryNoteAssignmentDto extends BaseDto {
    dispositionDate: string;
    order: number;
    deliveryNoteId: number;
    deliveryNote: DeliveryNoteDto;
    vehicleId: number;
    vehicle: VehicleDto;
}

export interface BaseReceiptVersionDtoOfDeliveryNotePositionDtoAndDeliveryNoteStatusDto extends BaseDto {
    versionNumber: number | null;
    deliveryDate: string | null;
    vat: number;
    headerText: string | null;
    footerText: string | null;
    kind: string;
    comment: string | null;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
    rentDurationAmount: number | null;
    rentDurationUnit: TimeUnit;
    numberOfTransports: number;
    price: ReceiptPriceDto | null;
    positions: DeliveryNotePositionDto[] | null;
    receiptId: number;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    createdBy: RuiterUserDto | null;
    createdById: number;
    billRecipient: CustomerDto | null;
    billRecipientId: number;
    statusId: number;
    status: DeliveryNoteStatusDto;
}

export interface DeliveryNoteVersionDto extends BaseReceiptVersionDtoOfDeliveryNotePositionDtoAndDeliveryNoteStatusDto {
    totalPlateCount: number | null;
    articlePlateCounts: ArticlePlateCountResultDto[];
    supportsMultipleAssignments: boolean;
}

export interface ArticlePlateCountResultDto {
    articleId: number;
    articleAbbrevation: string;
    isDeparture: boolean;
    totalPlateCount: number | null;
}

export interface DeliveryNotePositionDto extends BaseReceiptPositionDto {
}

export interface DeliveryNoteStatusDto extends BaseReceiptStatusDto {
}

export interface InvoicePositionDto extends BaseReceiptPositionDto {
}

export interface InvoiceStatusDto extends BaseReceiptStatusDto {
}

export interface ApiResponseOfDeliveryNoteDto extends ApiResponse {
    data: DeliveryNoteDto;
}

export interface DeliveryNoteDownloadOptionsDto {
    kind: string;
    positionIds: number[];
    supportsMultipleAssignments: boolean;
}

export interface ApiResponseOfIEnumerableOfInvoiceDto extends ApiResponse {
    data: InvoiceDto[];
}

export interface ApiResponseOfIEnumerableOfDeliveryNoteDto extends ApiResponse {
    data: DeliveryNoteDto[];
}

export interface ApiResponseOfIEnumerableOfOrderVersionDto extends ApiResponse {
    data: OrderVersionDto[];
}

export interface ApiResponseOfOfferDto extends ApiResponse {
    data: OfferDto;
}

export interface CreateOfferDto {
    kind: string;
    articles: CreateOfferArticleDto[];
    vat: number;
    externalCalculationCost: number | null;
    billRecipientId: number | null;
}

export interface CreateOfferConstructionProjectDto extends CreateOfferDto {
    constructionProjectId: number;
}

export interface CreateOfferArticleDto {
    articleId: number;
    plateCount: number;
    plateUnit: PlateUnit;
    rentDurationAmount: number;
    rentDurationUnit: TimeUnit;
}

export interface CreateOfferCustomerDto extends CreateOfferDto {
    customerId: number;
    address: AddressDto;
    constructionProjectDistance: number;
    warehouseId: number;
}

export interface ApiResponseOfOfferVersionDto extends ApiResponse {
    data: OfferVersionDto;
}

export interface RecalculateOfferDto {
    kind: string;
    externalCalculationCost: number | null;
    keepComment: boolean;
    removePositions: boolean;
    articles: CreateOfferArticleDto[];
}

export interface TransferOfferDto {
    costCenter: string;
    deliveryDate: string;
}

export interface AddMovePositionDto {
    articleId: number;
    plateCount: number;
    plateUnit: PlateUnit | null;
}

export interface OfferCustomCostsDto {
    amount: number;
}

export interface ApiResponseOfIEnumerableOfOfferDto extends ApiResponse {
    data: OfferDto[];
}

export interface ApiResponseOfOfferPositionDto extends ApiResponse {
    data: OfferPositionDto;
}

export interface ApiResponseOfListOfOfferVersionDto extends ApiResponse {
    data: OfferVersionDto[];
}

export interface ReceiptStatusUpdateDtoOfOfferDtoAndOfferStatusDto {
    newStatusId: number;
    receiptIds: number[];
}

export interface ApiResponseOfIEnumerableOfOfferVersionDto extends ApiResponse {
    data: OfferVersionDto[];
}

export interface ApiResponseOfListOfInvoicePaymentDto extends ApiResponse {
    data: InvoicePaymentDto[];
}

export interface ApiResponseOfInvoicePaymentDto extends ApiResponse {
    data: InvoicePaymentDto;
}

export interface InvoicePaymentCreateDto {
    invoiceId: number;
    paymentDate: string;
    paymentAmount: number;
    withDiscount: boolean;
    newStatusId: number;
}

export interface ApiResponseOfIEnumerableOfCreditNoteDto extends ApiResponse {
    data: CreditNoteDto[];
}

export interface BaseReceiptDtoOfCreditNoteVersionDtoAndCreditNotePositionDtoAndCreditNoteStatusDto extends BaseDto {
    latestVersion: CreditNoteVersionDto;
    isReadOnly: boolean;
    number: string | null;
    constructionProject: ConstructionProjectDto | null;
    constructionProjectId: number;
    createdBy: RuiterUserDto | null;
    createdById: number | null;
}

export interface CreditNoteDto extends BaseReceiptDtoOfCreditNoteVersionDtoAndCreditNotePositionDtoAndCreditNoteStatusDto {
    costCenter: string;
    transferredFromInvoice: InvoiceDto | null;
    transferredFromInvoiceId: number;
    hasDownloads: boolean | null;
}

export interface BaseReceiptVersionDtoOfCreditNotePositionDtoAndCreditNoteStatusDto extends BaseDto {
    versionNumber: number | null;
    deliveryDate: string | null;
    vat: number;
    headerText: string | null;
    footerText: string | null;
    kind: string;
    comment: string | null;
    rentalPeriodFrom: string | null;
    rentalPeriodTo: string | null;
    rentDurationAmount: number | null;
    rentDurationUnit: TimeUnit;
    numberOfTransports: number;
    price: ReceiptPriceDto | null;
    positions: CreditNotePositionDto[] | null;
    receiptId: number;
    paymentCondition: PaymentConditionDto | null;
    paymentConditionId: number | null;
    deliveryCondition: DeliveryConditionDto | null;
    deliveryConditionId: number | null;
    createdBy: RuiterUserDto | null;
    createdById: number;
    billRecipient: CustomerDto | null;
    billRecipientId: number;
    statusId: number;
    status: CreditNoteStatusDto;
}

export interface CreditNoteVersionDto extends BaseReceiptVersionDtoOfCreditNotePositionDtoAndCreditNoteStatusDto {
    creditNoteDate: string;
    isReleased: boolean;
    zugferdBuyerReference: string | null;
    zugferdOrderReference: string | null;
    zugferdProjectReference: string | null;
}

export interface CreditNotePositionDto extends BaseReceiptPositionDto {
}

export interface CreditNoteStatusDto extends BaseReceiptStatusDto {
}

export interface ApiResponseOfCreditNoteDto extends ApiResponse {
    data: CreditNoteDto;
}

export interface TransferInvoiceDto {
    creditNoteDate: string;
}

export interface ApiResponseOfInvoiceVersionDto extends ApiResponse {
    data: InvoiceVersionDto;
}

export interface AddUnsuccessfullDeliveryPositionDto {
    article: ArticleDto | null;
    articleId: number;
    totalCosts: number;
}

export interface AddWaitingTimePositionDto {
    waitDurationHours: number;
    vehicles: AddWaitingTimePositionVehicleDto[];
}

export interface AddWaitingTimePositionVehicleDto {
    vehicleType: VehicleTypeDto | null;
    vehicleTypeId: number;
    vehicleCount: number;
}

export interface AddRollingPositionDto {
    article: ArticleDto | null;
    articleId: number;
    plateCount: number;
}

export interface AddCleaningPositionDto {
    article: ArticleDto | null;
    articleId: number;
    plateCount: number;
}

export interface ReceiptSystemPropertiesDtoOfInvoiceStatusDto {
    status: InvoiceStatusDto;
    statusId: number | null;
    comment: string | null;
}

export interface AddTheftProtectionPositionDto {
    articles: ArticleInfoDto[];
}

export interface ArticleInfoDto {
    articleId: number;
    amount: number;
    amountUnit: string;
}

export interface ApiResponseOfInvoicePositionDto extends ApiResponse {
    data: InvoicePositionDto;
}

export interface ApiResponseOfListOfInvoiceVersionDto extends ApiResponse {
    data: InvoiceVersionDto[];
}

export interface ReceiptStatusUpdateDtoOfInvoiceDtoAndInvoiceStatusDto {
    newStatusId: number;
    receiptIds: number[];
}

export interface ApiResponseOfIEnumerableOfInvoiceVersionDto extends ApiResponse {
    data: InvoiceVersionDto[];
}

export interface ApiResponseOfIEnumerableOfDeliveryNoteAssignmentDto extends ApiResponse {
    data: DeliveryNoteAssignmentDto[];
}

export interface ApiResponseOfDeliveryNoteAssignmentDto extends ApiResponse {
    data: DeliveryNoteAssignmentDto;
}

export interface ApiResponseOfIListOfDeliveryNoteAssignmentDto extends ApiResponse {
    data: DeliveryNoteAssignmentDto[];
}

export interface ApiResponseOfListOfApiResponseOfDeliveryNoteAssignmentDto extends ApiResponse {
    data: ApiResponseOfDeliveryNoteAssignmentDto[];
}

export interface ApiResponseOfMailDataDto extends ApiResponse {
    data: MailDataDto;
}

export interface MailDataDto {
    subject: string;
    to: string[];
    cc: string[];
    bcc: string[];
    htmlMail: string;
    textMail: string;
    attachments: MailAttachmentDataDto[];
}

export interface MailAttachmentDataDto {
    fileName: string;
    contentType: string | null;
    data: string;
}

export interface ApiSeekPaginationResponseOfDeliveryNoteDto {
    firstItemId: number | null;
    lastItemId: number | null;
    items: DeliveryNoteDto[];
}

export interface ApiResponseOfIListOfDeliveryNoteDto extends ApiResponse {
    data: DeliveryNoteDto[];
}

export interface ApiResponseOfDeliveryNoteVersionDto extends ApiResponse {
    data: DeliveryNoteVersionDto;
}

export interface ApiResponseOfDeliveryNotePositionDto extends ApiResponse {
    data: DeliveryNotePositionDto;
}

export interface ApiResponseOfListOfDeliveryNoteVersionDto extends ApiResponse {
    data: DeliveryNoteVersionDto[];
}

export interface ReceiptStatusUpdateDtoOfDeliveryNoteDtoAndDeliveryNoteStatusDto {
    newStatusId: number;
    receiptIds: number[];
}

export interface ApiResponseOfDeliveryNoteReplyDto extends ApiResponse {
    data: DeliveryNoteReplyDto;
}

export interface DeliveryNoteReplyDto extends BaseDto {
    deliveryDateFrom: string;
    deliveryDateTo: string;
    operatingTimes: DeliveryNoteReplyTimeRangeDto[];
    waitingTimeInHours: number | null;
    waitingReason: string | null;
    dirtyPlateCount: number;
    damagedPlateCount: number;
    unloadedOtherVehicleCount: number;
    hasImages: boolean;
    remarks: string | null;
    customerLiabilityName: string | null;
    contactPersonName: string | null;
    contactPersonPhonenumber: string | null;
    contactPersonPhonenumberMobile: string | null;
    customerSignatureId: number | null;
    customerSignature: SignatureDto | null;
    customerLiabilitySignatureId: number | null;
    customerLiabilitySignature: SignatureDto | null;
    driverSignatureId: number;
    driverSignature: SignatureDto;
    deliveryNoteId: number;
    deliveryNote: DeliveryNoteDto | null;
    positions: DeliveryNoteReplyPositionDto[];
    status: DeliveryNoteReplyStatusDto;
    statusId: number;
    createdById: number | null;
    createdBy: RuiterUserDto | null;
}

export interface TimeRangeDto extends BaseDto {
    from: string;
    to: string;
}

export interface DeliveryNoteReplyTimeRangeDto extends TimeRangeDto {
    deliveryNoteReply: DeliveryNoteReplyDto | null;
    deliveryNoteReplyId: number | null;
}

export interface SignatureDto extends BaseDto {
    signatureData: string;
}

export interface DeliveryNoteReplyPositionDto extends BaseDto {
    plateCount: number;
    articleId: number;
    article: ArticleDto | null;
    replyId: number;
    reply: DeliveryNoteReplyDto | null;
}

export interface DeliveryNoteReplyStatusDto extends BaseReceiptStatusDto {
}

export interface ApiResponseOfListOfDeliveryNoteReplyWithOnlyCreatedDateDto extends ApiResponse {
    data: DeliveryNoteReplyWithOnlyCreatedDateDto[];
}

export interface DeliveryNoteReplyWithOnlyCreatedDateDto {
    id: number | null;
    deliveryNoteId: number;
    created: string;
}

export interface ApiResponseOfIEnumerableOfDeliveryNoteReplyDto extends ApiResponse {
    data: DeliveryNoteReplyDto[];
}

export interface DeliveryNoteReplyUpdateDto {
    replyId: number;
    receiptKind: string;
    statusId: number;
    deliveryDateFrom: string;
    deliveryDateTo: string;
    operatingTimes: DeliveryNoteReplyTimeRangeDto[];
    waitingTimeInHours: number | null;
    waitingReason: string | null;
    dirtyPlateCount: number;
    damagedPlateCount: number;
    unloadedOtherVehicleCount: number;
    hasImages: boolean;
    remarks: string | null;
    positions: DeliveryNoteReplyPositionDto[];
}

export interface ApiResponseOfListOfApiResponseOfDeliveryNoteReplyDto extends ApiResponse {
    data: ApiResponseOfDeliveryNoteReplyDto[];
}

export interface ApiResponseOfIEnumerableOfDeliveryNoteVersionDto extends ApiResponse {
    data: DeliveryNoteVersionDto[];
}

export interface ApiResponseOfListOfDispositionMailDraftListItemDto extends ApiResponse {
    data: DispositionMailDraftListItemDto[];
}

export interface DispositionMailDraftListItemDto {
    id: number | null;
    subject: string;
    to: string[];
    lastChange: string;
}

export interface ApiResponseOfDispositionMailDraftDto extends ApiResponse {
    data: DispositionMailDraftDto;
}

export interface DispositionMailDraftDto extends BaseDto {
    subject: string;
    to: string[];
    cc: string[];
    bcc: string[];
    htmlMail: string;
    textMail: string;
    attachments: MailAttachmentDataDto[];
}

export interface ApiResponseOfCreditNoteVersionDto extends ApiResponse {
    data: CreditNoteVersionDto;
}

export interface ReceiptSystemPropertiesDtoOfCreditNoteStatusDto {
    status: CreditNoteStatusDto;
    statusId: number | null;
    comment: string | null;
}

export interface ApiResponseOfCreditNotePositionDto extends ApiResponse {
    data: CreditNotePositionDto;
}

export interface ApiResponseOfListOfCreditNoteVersionDto extends ApiResponse {
    data: CreditNoteVersionDto[];
}

export interface ReceiptStatusUpdateDtoOfCreditNoteDtoAndCreditNoteStatusDto {
    newStatusId: number;
    receiptIds: number[];
}

export interface ApiResponseOfIEnumerableOfCreditNoteVersionDto extends ApiResponse {
    data: CreditNoteVersionDto[];
}

export interface ApiResponseOfIEnumerableOfRapDto extends ApiResponse {
    data: RapDto[];
}

export interface RapDto extends BaseDto {
    order: OrderDto;
    orderId: number;
    sumAmount: number;
    startDate: string;
    endDate: string | null;
    comment: string | null;
}

export interface ApiResponseOfRapDto extends ApiResponse {
    data: RapDto;
}

export interface ApiResponseOfListOfApiResponseOfRapDto extends ApiResponse {
    data: ApiResponseOfRapDto[];
}

export interface ApiResponseOfIEnumerableOfCountryDto extends ApiResponse {
    data: CountryDto[];
}

export interface ApiResponseOfIEnumerableOfConstructionProjectDto extends ApiResponse {
    data: ConstructionProjectDto[];
}

export interface ApiResponseOfIEnumerableOfContactPersonDto extends ApiResponse {
    data: ContactPersonDto[];
}

export interface ContactPersonDto extends BaseDto {
    salutation: Salutation;
    position: string | null;
    firstname: string | null;
    lastname: string | null;
    company: string | null;
    comment: string | null;
    contactOptions: ContactOptionsDto | null;
    customers: CustomerDto[];
    constructionProjects: ConstructionProjectDto[];
    indirectCustomers: CustomerDto[];
}

export interface ApiResponseOfCustomerContactPersonDto extends ApiResponse {
    data: CustomerContactPersonDto;
}

export interface CustomerContactPersonDto extends BaseDto {
    customerId: number | null;
    contactPersonId: number | null;
}

export interface ApiResponseOfListOfApiResponseOfCustomerContactPersonDto extends ApiResponse {
    data: ApiResponseOfCustomerContactPersonDto[];
}

export interface ApiResponseOfIEnumerableOfCustomerDto extends ApiResponse {
    data: CustomerDto[];
}

export interface ApiResponseOfCustomerDto extends ApiResponse {
    data: CustomerDto;
}

export interface ApiResponseOfListOfApiResponseOfCustomerDto extends ApiResponse {
    data: ApiResponseOfCustomerDto[];
}

export interface ApiResponseOfIEnumerableOfDeliveryConditionDto extends ApiResponse {
    data: DeliveryConditionDto[];
}

export interface ApiResponseOfDeliveryConditionDto extends ApiResponse {
    data: DeliveryConditionDto;
}

export interface ApiResponseOfListOfApiResponseOfDeliveryConditionDto extends ApiResponse {
    data: ApiResponseOfDeliveryConditionDto[];
}

export interface ApiResponseOfIEnumerableOfPaymentConditionDto extends ApiResponse {
    data: PaymentConditionDto[];
}

export interface ApiResponseOfPaymentConditionDto extends ApiResponse {
    data: PaymentConditionDto;
}

export interface ApiResponseOfListOfApiResponseOfPaymentConditionDto extends ApiResponse {
    data: ApiResponseOfPaymentConditionDto[];
}

export interface ApiResponseOfConstructionProjectContactPersonDto extends ApiResponse {
    data: ConstructionProjectContactPersonDto;
}

export interface ConstructionProjectContactPersonDto extends BaseDto {
    constructionProjectId: number | null;
    contactPersonId: number | null;
}

export interface ApiResponseOfListOfApiResponseOfConstructionProjectContactPersonDto extends ApiResponse {
    data: ApiResponseOfConstructionProjectContactPersonDto[];
}

export interface ApiResponseOfContactPersonDto extends ApiResponse {
    data: ContactPersonDto;
}

export interface ApiResponseOfListOfApiResponseOfContactPersonDto extends ApiResponse {
    data: ApiResponseOfContactPersonDto[];
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export interface ApiResponseOfListOfContactPersonDto extends ApiResponse {
    data: ContactPersonDto[];
}

export interface ApiResponseOfConstructionProjectContactPersonsDto extends ApiResponse {
    data: ConstructionProjectContactPersonsDto;
}

export interface ConstructionProjectContactPersonsDto {
    contactPersons: ConstructionProjectContactPersonDto[];
}

export interface ApiResponseOfConstructionProjectDto extends ApiResponse {
    data: ConstructionProjectDto;
}

export interface ApiResponseOfIEnumerableOfAmountUnitDto extends ApiResponse {
    data: AmountUnitDto[];
}

export interface AmountUnitDto extends BaseDto {
    name: string;
    symbol: string | null;
}

export interface ApiResponseOfAmountUnitDto extends ApiResponse {
    data: AmountUnitDto;
}

export interface ApiResponseOfIEnumerableOfTimeUnitDto extends ApiResponse {
    data: TimeUnitDto[];
}

export interface TimeUnitDto extends BaseDto {
    name: string;
    symbol: string | null;
}

export interface ApiResponseOfTimeUnitDto extends ApiResponse {
    data: TimeUnitDto;
}

export interface ApiResponseOfListOfInvoiceDto extends ApiResponse {
    data: InvoiceDto[];
}

export interface ApiResponseOfListOfOfferDto extends ApiResponse {
    data: OfferDto[];
}

export interface ApiResponseOfListOfOrderDto extends ApiResponse {
    data: OrderDto[];
}

export interface ApiResponseOfApiInfo extends ApiResponse {
    data: ApiInfo;
}

export interface ApiInfo {
    name: string;
    version: string;
    environment: string;
    buildTimeUtc: string;
    os: string;
}

export interface ApiResponseOfLoginResultDtoOfRuiterUserDto extends ApiResponse {
    data: LoginResultDtoOfRuiterUserDto;
}

export interface LoginResultDtoOfRuiterUserDto {
    tokenData: TokenRenewalResultDtoOfRuiterUserDto | null;
    isUserDisabled: boolean;
}

export interface TokenRenewalResultDtoOfRuiterUserDto {
    token: string;
    refreshToken: string;
    validUntil: string;
    user: RuiterUserDto;
}

export interface LoginDto {
    username: string;
    password: string;
}

export interface LogoutDto {
    refreshToken: string;
}

export interface ApiResponseOfTokenRenewalResultDtoOfRuiterUserDto extends ApiResponse {
    data: TokenRenewalResultDtoOfRuiterUserDto;
}

export interface ApiResponseOfModelStateDictionary extends ApiResponse {
    data: any[];
}

export interface TokenRenewalDto {
    username: string;
    refreshToken: string;
}

export interface ApiResponseOfIEnumerableOfPermissionDto extends ApiResponse {
    data: PermissionDto[];
}

export interface PermissionDto {
    key: string;
    translations: { [key: string]: PermissionTranslationDto; };
}

export interface PermissionTranslationDto {
    title: string;
    description: string;
}

export interface ImpersonateDto {
    userId: number;
}

export interface ChangePasswordDto {
    oldPassword: string;
    newPassword: string;
}

export interface ForgotPasswordDto {
    mailAddress: string;
}

export interface ResetPasswordDto {
    token: string | null;
    password: string | null;
}

export interface ActivateUserDto {
    activationToken: string | null;
    firstname: string | null;
    lastname: string | null;
    password: string | null;
}

export interface ApiResponseOfRuiterUserDto extends ApiResponse {
    data: RuiterUserDto;
}

export interface InviteUserDto {
    mailAddress: string;
}

export interface ReinviteUserDto {
    userId: number;
}

export interface ApiResponseOfIEnumerableOfRuiterUserDto extends ApiResponse {
    data: RuiterUserDto[];
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    return _observableThrow(new ApiException(message, status, response, headers, result));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}